// This file is auto-generated by @hey-api/openapi-ts

import type { CancelablePromise } from "./core/CancelablePromise";
import { OpenAPI } from "./core/OpenAPI";
import { request as __request } from "./core/request";
import type {
  GetBookmarksData,
  GetBookmarksResponse,
  CreateBookmarkData,
  CreateBookmarkResponse,
  DeleteBookmarkData,
  DeleteBookmarkResponse,
  GetSessionsData,
  GetSessionsResponse,
  GetSessionBySlugData,
  GetSessionBySlugResponse,
  GetSessionInteractionsData,
  GetSessionInteractionsResponse,
  GetCategoriesResponse,
  GetChaptersData,
  GetChaptersResponse,
  GetCoursesData,
  GetCoursesResponse,
  GetCourseBySlugData,
  GetCourseBySlugResponse,
  GetCoursesContentGemsData,
  GetCoursesContentGemsResponse,
  GetContentRowsData,
  GetContentRowsResponse,
  GetContentRowByIdData,
  GetContentRowByIdResponse,
  GetConversationsData,
  GetConversationsResponse,
  CreateConversationData,
  CreateConversationResponse,
  GetConversationIntroductionData,
  GetConversationIntroductionResponse,
  GetConversationData,
  GetConversationResponse,
  GetConversationMessagesData,
  GetConversationMessagesResponse,
  CreateConversationMessageData,
  CreateConversationMessageResponse,
  UpsertConversationMessageData,
  UpsertConversationMessageResponse,
  GetConversationMessageData,
  GetConversationMessageResponse,
  UpdateConversationMessageData,
  UpdateConversationMessageResponse,
  CreateEmailConfirmationData,
  CreateEmailConfirmationResponse,
  GetEmailConfirmationData,
  GetEmailConfirmationResponse,
  GetLegacyEmailConfirmationResponse,
  CreateLegacyEmailConfirmationData,
  CreateLegacyEmailConfirmationResponse,
  DownloadExampleCsvResponse,
  GetEnterpriseSubscriptionsResponse,
  GetNotificationsResponse,
  ClearNotificationsData,
  ClearNotificationsResponse,
  GetScheduledInvitationData,
  GetScheduledInvitationResponse,
  UpdateScheduledInviteData,
  UpdateScheduledInviteResponse,
  CancelScheduledInviteData,
  CancelScheduledInviteResponse,
  GetScheduledInvitationCsvData,
  GetScheduledInvitationCsvResponse,
  CreateTeamData,
  CreateTeamResponse,
  GetTeamData,
  GetTeamResponse,
  DeleteTeamData,
  DeleteTeamResponse,
  UpdateTeamData,
  UpdateTeamResponse,
  AddAdminByEmailData,
  AddAdminByEmailResponse,
  RemindUserData,
  RemindUserResponse,
  UpdateTeamUserData,
  UpdateTeamUserResponse,
  AddUserData,
  AddUserResponse,
  DeleteUserData,
  DeleteUserResponse,
  AddAdminData,
  AddAdminResponse,
  SetAdminRoleData,
  SetAdminRoleResponse,
  GetScheduledInvitationsData,
  GetScheduledInvitationsResponse,
  GetOrganizationData,
  GetOrganizationResponse,
  RemoveLogoData,
  RemoveLogoResponse,
  SaveOrganizationMessageData,
  SaveOrganizationMessageResponse,
  GetOrganizationMessageData,
  GetOrganizationMessageResponse,
  DeleteOrganizationMessageData,
  DeleteOrganizationMessageResponse,
  DismissOrganizationMessageData,
  DismissOrganizationMessageResponse,
  GetUnreadOrganizationMessageResponse,
  GetEpisodesData,
  GetEpisodesResponse,
  GetEpisodeBySlugData,
  GetEpisodeBySlugResponse,
  GetExperimentsResponse,
  GetFeatureInteractionsData,
  GetFeatureInteractionsResponse,
  UpdateFeatureInteractionData,
  UpdateFeatureInteractionResponse,
  GetGuestPassesData,
  GetGuestPassesResponse,
  SendGuestPassViaEmailData,
  SendGuestPassViaEmailResponse,
  GetImmersiveHerosData,
  GetImmersiveHerosResponse,
  GetInstructorsData,
  GetInstructorsResponse,
  GetNotesData,
  GetNotesResponse,
  CreateNoteData,
  CreateNoteResponse,
  DeleteNoteData,
  DeleteNoteResponse,
  UpdateNoteData,
  UpdateNoteResponse,
  GetPlaylistData,
  GetPlaylistResponse,
  GetPlaylistsData,
  GetPlaylistsResponse,
  GetProductsData,
  GetProductsResponse,
  GetProfilesData,
  GetProfilesResponse,
  CreateProfileData,
  CreateProfileResponse,
  GetProfileData,
  GetProfileResponse,
  UpdateProfileData,
  UpdateProfileResponse,
  DeleteProfileData,
  DeleteProfileResponse,
  GetOnboardingContentRecommendationResponse,
  GetPurchasePlanData,
  GetPurchasePlanResponse,
  GetReferralAudioProgramsResponse,
  CreateShareableGuestPassLinksData,
  CreateShareableGuestPassLinksResponse,
  GetShowcasesData,
  GetShowcasesResponse,
  GetSkillsResponse,
  GetLastUserSubscriptionData,
  GetLastUserSubscriptionResponse,
  GetThemesData,
  GetThemesResponse,
  GetCurrentTierCollectionData,
  GetCurrentTierCollectionResponse,
  GetPersonaBundleTierCollectionData,
  GetPersonaBundleTierCollectionResponse,
  GetUserCartDataData,
  GetUserCartDataResponse,
  GetUserGuestPassesResponse,
  GetLastUserProductResponse,
  ValidateStreamConcurrencyData,
  ValidateStreamConcurrencyResponse,
  ReleaseConcurrentSeatData,
  ReleaseConcurrentSeatResponse,
  GetUserSessionsResponse,
  GetUserCoursesData,
  GetUserCoursesResponse,
  CreateUserCourseData,
  CreateUserCourseResponse,
  GetUserCourseBySlugData,
  GetUserCourseBySlugResponse,
  GetUserProgressData,
  GetUserProgressResponse,
  GetUserPlaylistsData,
  GetUserPlaylistsResponse,
  GetUserData,
  GetUserResponse,
  UpdateUserData,
  UpdateUserResponse,
  GetVideoProgressEntriesData,
  GetVideoProgressEntriesResponse,
  CreateVideoProgressEntryData,
  CreateVideoProgressEntryResponse,
  UpdateVideoProgressEntryData,
  UpdateVideoProgressEntryResponse,
  GetWatchListItemsData,
  GetWatchListItemsResponse,
  CreateWatchListItemData,
  CreateWatchListItemResponse,
  DeleteWatchListItemData,
  DeleteWatchListItemResponse,
  GetLandingPricesData,
  GetLandingPricesResponse,
  GetPersonaBundleResponse,
  GetSearchConfigData,
  GetSearchConfigResponse,
  GetRegisteredEmailData,
  GetRegisteredEmailResponse,
  CompleteUserRegistrationData,
  CompleteUserRegistrationResponse,
  AddCreditCardData,
  AddCreditCardResponse,
  GetCreditCardsResponse,
  RemoveCreditCardData,
  RemoveCreditCardResponse,
  GetCreditCardsWithCurrencyData,
  GetCreditCardsWithCurrencyResponse,
  GetDefaultCreditCardResponse,
  CheckSetupIntentStatusData,
  CheckSetupIntentStatusResponse,
  VerifyCouponData,
  VerifyCouponResponse,
  CreateOrderData,
  CreateOrderResponse,
  ConfirmData,
  ConfirmResponse,
  AddDiscountToCartProductsData,
  AddDiscountToCartProductsResponse,
  AddProductToCartData,
  AddProductToCartResponse,
  ClearCartResponse,
  RemoveProductFromCartData,
  RemoveProductFromCartResponse,
  GetCartProductsData,
  GetCartProductsResponse,
  RedeemData,
  RedeemResponse,
  GetGiftAddOnResponse,
  GetAddOnsResponse,
  GetLearningToolkitAddOnResponse,
  GetPersonaAddOnResponse,
  PreviewProrationData,
  PreviewProrationResponse,
  CancelData,
  CancelResponse,
  ReactivateData,
  ReactivateResponse,
  PreviewData,
  PreviewResponse,
  UpdateData,
  UpdateResponse,
  PricingUpgradeResponse,
  GetWatchBundleData,
  GetWatchBundleResponse,
  GetWatchBundleExtrasData,
  GetWatchBundleExtrasResponse,
  GetWatchBundleInteractionsData,
  GetWatchBundleInteractionsResponse,
  AddBookmarkData,
  AddBookmarkResponse,
  RemoveBookmarkData,
  RemoveBookmarkResponse,
  PatchNoteData,
  PatchNoteResponse,
  DestroyNoteData,
  DestroyNoteResponse,
  GetWatchBundleContentInteractionsData,
  GetWatchBundleContentInteractionsResponse,
  PatchPlaybackData,
  PatchPlaybackResponse,
  GetPlaybackTokenResponse,
  UpdateSurveyResponseData,
  UpdateSurveyResponseResponse,
  ShowSharingData,
  ShowSharingResponse,
  GetSessionActivityInteractionsData,
  GetSessionActivityInteractionsResponse,
  GetAssigneesResponse,
  GetContentProgressData,
  GetContentProgressResponse,
  GetAssignmentsResponse,
  CreateAssignmentsData,
  CreateAssignmentsResponse,
  DestroyAssignmentData,
  DestroyAssignmentResponse,
  GetAssignableContentResponse,
  GetNavigationResponse,
  GetOrganizationInfoData,
  GetOrganizationInfoResponse,
  GetTemplateBulkImportResponse,
  GetEnterpriseSkillsResponse,
  V3GetPlaylistsData,
  V3GetPlaylistsResponse,
  CreatePlaylistData,
  CreatePlaylistResponse,
  V3GetPlaylistData,
  V3GetPlaylistResponse,
  UpdatePlaylistData,
  UpdatePlaylistResponse,
  DeletePlaylistData,
  DeletePlaylistResponse,
  PublishPlaylistData,
  PublishPlaylistResponse,
  UnpublishPlaylistData,
  UnpublishPlaylistResponse,
  DuplicatePlaylistData,
  DuplicatePlaylistResponse,
  GetLessonsFromPlaylistData,
  GetLessonsFromPlaylistResponse,
  AddLessonsToPlaylistData,
  AddLessonsToPlaylistResponse,
  ReorderLessonsInPlaylistData,
  ReorderLessonsInPlaylistResponse,
  UpdateLessonInPlaylistData,
  UpdateLessonInPlaylistResponse,
  RemoveLessonFromPlaylistData,
  RemoveLessonFromPlaylistResponse,
  GetProgramData,
  GetProgramResponse,
  EnrollProgramsData,
  EnrollProgramsResponse,
  GetProgramDownloadResourcesData,
  GetProgramDownloadResourcesResponse,
  GetModuleDownloadResourcesData,
  GetModuleDownloadResourcesResponse,
  GetQuoteData,
  GetQuoteResponse,
  GetAddonQuoteData,
  GetAddonQuoteResponse,
  ProcessAddonOrderData,
  ProcessAddonOrderResponse,
  ProcessOrderData,
  ProcessOrderResponse,
  GetInvoiceData,
  GetInvoiceResponse,
  GetLicensesResponse,
  RevokeConsentResponse,
  GetMetricData,
  GetMetricResponse,
  CreateGenerateCsvReportJobData,
  CreateGenerateCsvReportJobResponse,
  GetGenerateCsvReportJobData,
  GetGenerateCsvReportJobResponse,
  GetContentRowsV3Data,
  GetContentRowsV3Response,
  GetResourceUniqueIdentifierData,
  GetResourceUniqueIdentifierResponse,
  GetMyListResponse,
  AddToMyListData,
  AddToMyListResponse,
  RemoveFromMyListData,
  RemoveFromMyListResponse,
  GetHomepageLayoutResponse,
  GetSemanticSearchData,
  GetSemanticSearchResponse,
  GetAppDataResponse,
  UpdateLearningPreferencesData,
  UpdateLearningPreferencesResponse,
  GetCareerGoalResponse,
  V3GetSkillsData,
  V3GetSkillsResponse,
  GetSubskillsData,
  GetSubskillsResponse,
  GetTabContentData,
  GetTabContentResponse,
  GetCollectionRowsResponse,
  GetCollectionData,
  GetCollectionResponse,
  UpdateCardProgressData,
  UpdateCardProgressResponse,
  GetCollectionInteractionsData,
  GetCollectionInteractionsResponse,
  CreateOnboardingResponse,
  UpdateOnboardingData,
  UpdateOnboardingResponse,
  UpdateSessionPreferencesData,
  UpdateSessionPreferencesResponse,
  GetIterableTokenResponse,
  GetEligibleInfoData,
  GetEligibleInfoResponse,
  ActivateRevolutGiftData,
  ActivateRevolutGiftResponse,
  GetCertificateProgramCatalogResponse,
  GetCertificateHubTilesResponse,
  GetCertificateProgramInteractionsData,
  GetCertificateProgramInteractionsResponse,
  GetCertificateProgramData,
  GetCertificateProgramResponse,
  GetCurriculumData,
  GetCurriculumResponse,
  PostCurriculumInteractionsData,
  PostCurriculumInteractionsResponse,
  GetCurriculumLessonData,
  GetCurriculumLessonResponse,
  GetCurriculumLessonInteractionsData,
  GetCurriculumLessonInteractionsResponse,
  PostCurriculumLessonInteractionsData,
  PostCurriculumLessonInteractionsResponse,
  GetCurriculumLessonDownloadResourcesData,
  GetCurriculumLessonDownloadResourcesResponse,
  DownloadCurriculumCapstoneSummaryData,
  DownloadCurriculumCapstoneSummaryResponse,
  SubmitCurriculumQuizActivityData,
  SubmitCurriculumQuizActivityResponse,
  SubmitCurriculumDiscussionActivityData,
  SubmitCurriculumDiscussionActivityResponse,
  PostCurriculumActivityReadData,
  PostCurriculumActivityReadResponse,
  GetCertificateProgramProductData,
  GetCertificateProgramProductResponse,
  ListCertificateProgramProductsData,
  ListCertificateProgramProductsResponse,
  GetCertificateProgramProductByUuidData,
  GetCertificateProgramProductByUuidResponse,
  GetCertificateProgramRewardData,
  GetCertificateProgramRewardResponse,
  PostCertificateProgramRewardData,
  PostCertificateProgramRewardResponse,
  PostCertificateProgramAddOnData,
  PostCertificateProgramAddOnResponse,
  GetCertificateProgramCouponData,
  GetCertificateProgramCouponResponse,
  GetCertificateProgramEnrollmentsData,
  GetCertificateProgramEnrollmentsResponse,
  GetCertificateProgramEnrollmentData,
  GetCertificateProgramEnrollmentResponse,
  EnrollInCertificateProgramData,
  EnrollInCertificateProgramResponse,
  WithdrawFromCertificateProgramData,
  WithdrawFromCertificateProgramResponse,
  V3GetUserData,
  V3GetUserResponse,
  GetGrowthCategoriesResponse,
  GetGrowthContentResponse,
  GetQuizRecommendedLessonsResponse,
  GetQuizCategoryMediaResponse,
  GetOutcomesResponse,
  GetContentOutcomesResponse,
  CreateEmailCaptureData,
  CreateEmailCaptureResponse,
  GetUserTokenResponse,
  GetCommerceProductData,
  GetCommerceProductResponse,
  GetCommercePurchasePlansData,
  GetCommercePurchasePlansResponse,
  RedeemGiftcardData,
  RedeemGiftcardResponse,
} from "./types.gen";

export class BookmarksService {
  /**
   * Get list of bookmarks
   * @param data The data for the request.
   * @param data.deep include dependencies
   * @param data.filterBookmarkeeType Filter by given bookmarked entity type
   * @param data.filterBookmarkeeIds Filter by given bookmarked entity id
   * @returns Bookmarks List of bookmarks
   * @throws ApiError
   */
  public static getBookmarks(
    data: GetBookmarksData = {}
  ): CancelablePromise<GetBookmarksResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/jsonapi/v1/bookmarks",
      query: {
        deep: data.deep,
        "filter[bookmarkee_type]": data.filterBookmarkeeType,
        "filter[bookmarkee_ids]": data.filterBookmarkeeIds,
      },
    });
  }

  /**
   * Create a bookmark
   * @param data The data for the request.
   * @param data.requestBody Bookmark attributes
   * @param data.deep include dependencies
   * @returns Bookmark Created bookmark
   * @throws ApiError
   */
  public static createBookmark(
    data: CreateBookmarkData
  ): CancelablePromise<CreateBookmarkResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/jsonapi/v1/bookmarks",
      query: {
        deep: data.deep,
      },
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * Deletes a Bookmark by the given id
   * @param data The data for the request.
   * @param data.id
   * @returns void Bookmark is deleted
   * @throws ApiError
   */
  public static deleteBookmark(
    data: DeleteBookmarkData
  ): CancelablePromise<DeleteBookmarkResponse> {
    return __request(OpenAPI, {
      method: "DELETE",
      url: "/jsonapi/v1/bookmarks/{id}",
      path: {
        id: data.id,
      },
    });
  }
}

export class SessionsService {
  /**
   * Get sessions
   * @param data The data for the request.
   * @param data.deep include dependencies
   * @param data.hub include hub dependencies
   * @param data.excludedSlug slug to be remove from response
   * @returns SessionsResult Sessions response
   * @throws ApiError
   */
  public static getSessions(
    data: GetSessionsData = {}
  ): CancelablePromise<GetSessionsResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/jsonapi/v1/camps",
      query: {
        deep: data.deep,
        hub: data.hub,
        excludedSlug: data.excludedSlug,
      },
    });
  }

  /**
   * Get session by slug
   * @param data The data for the request.
   * @param data.slug slug id
   * @param data.deep include dependencies
   * @returns SingleSessionResult Session response
   * @throws ApiError
   */
  public static getSessionBySlug(
    data: GetSessionBySlugData
  ): CancelablePromise<GetSessionBySlugResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/jsonapi/v1/camps/{slug}",
      path: {
        slug: data.slug,
      },
      query: {
        deep: data.deep,
      },
    });
  }

  /**
   * GET session interactions
   * @param data The data for the request.
   * @param data.sessionUuid
   * @returns SessionsInteractions OK
   * @throws ApiError
   */
  public static getSessionInteractions(
    data: GetSessionInteractionsData
  ): CancelablePromise<GetSessionInteractionsResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/v3/sessions/{session_uuid}/interactions",
      path: {
        session_uuid: data.sessionUuid,
      },
      errors: {
        401: `The authentication credentials required to access this resource are missing or invalid.
`,
        404: `The resource could not be found. Either the resource does not exist or the user does not have authorization to access the resource.
`,
      },
    });
  }
}

export class CategoriesService {
  /**
   * Get list of content categories
   * @returns CategoriesResult List of categories
   * @throws ApiError
   */
  public static getCategories(): CancelablePromise<GetCategoriesResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/jsonapi/v1/categories",
    });
  }
}

export class ChaptersService {
  /**
   * Get chapters
   * @param data The data for the request.
   * @param data.deep include dependencies
   * @param data.filter
   * @returns ChapterResult Chapter response
   * @throws ApiError
   */
  public static getChapters(
    data: GetChaptersData = {}
  ): CancelablePromise<GetChaptersResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/jsonapi/v1/chapters",
      query: {
        deep: data.deep,
        filter: data.filter,
      },
    });
  }
}

export class CoursesService {
  /**
   * Get courses
   * @param data The data for the request.
   * @param data.deep include dependencies
   * @param data.filter
   * @returns CoursesResult Courses response
   * @throws ApiError
   */
  public static getCourses(
    data: GetCoursesData = {}
  ): CancelablePromise<GetCoursesResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/jsonapi/v1/courses",
      query: {
        deep: data.deep,
        filter: data.filter,
      },
    });
  }

  /**
   * Get courses
   * @param data The data for the request.
   * @param data.slug Course slug
   * @param data.filter Filters courses by tag
   * @param data.deep include dependencies
   * @returns unknown Courses response
   * @throws ApiError
   */
  public static getCourseBySlug(
    data: GetCourseBySlugData
  ): CancelablePromise<GetCourseBySlugResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/jsonapi/v1/courses/{slug}",
      path: {
        slug: data.slug,
      },
      query: {
        filter: data.filter,
        deep: data.deep,
      },
    });
  }

  /**
   * Get mobile content gems for a course
   * @param data The data for the request.
   * @param data.id Course id
   * @returns MobileContentGems Mobile content gems response
   * @throws ApiError
   */
  public static getCoursesContentGems(
    data: GetCoursesContentGemsData
  ): CancelablePromise<GetCoursesContentGemsResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/jsonapi/v1/courses/{id}/content-gems",
      path: {
        id: data.id,
      },
    });
  }
}

export class ContentRowsV2Service {
  /**
   * Get list of content rows
   * @param data The data for the request.
   * @param data.pageSlug
   * @param data.platform
   * @returns ContentRows List of content rows
   * @throws ApiError
   */
  public static getContentRows(
    data: GetContentRowsData = {}
  ): CancelablePromise<GetContentRowsResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/jsonapi/v2/content-rows",
      query: {
        page_slug: data.pageSlug,
        platform: data.platform,
      },
    });
  }

  /**
   * Get content row by ID
   * @param data The data for the request.
   * @param data.id Content row ID
   * @param data.deep include dependencies
   * @returns ContentRow Content row response
   * @throws ApiError
   */
  public static getContentRowById(
    data: GetContentRowByIdData
  ): CancelablePromise<GetContentRowByIdResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/jsonapi/v2/content-rows/{id}",
      path: {
        id: data.id,
      },
      query: {
        deep: data.deep,
      },
    });
  }
}

export class ConversationsService {
  /**
   * Get conversations
   * @param data The data for the request.
   * @param data.filterCourseId filters by course
   * @param data.filterVisitSessionId filters by client session
   * @param data.sort Sort by attribute
   * @returns Conversations Conversation response
   * @throws ApiError
   */
  public static getConversations(
    data: GetConversationsData = {}
  ): CancelablePromise<GetConversationsResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/jsonapi/v1/conversations",
      query: {
        "filter[course_id]": data.filterCourseId,
        "filter[visit_session_id]": data.filterVisitSessionId,
        sort: data.sort,
      },
    });
  }

  /**
   * Create a conversation
   * @param data The data for the request.
   * @param data.requestBody Conversation attributes
   * @returns Conversation Created note
   * @throws ApiError
   */
  public static createConversation(
    data: CreateConversationData
  ): CancelablePromise<CreateConversationResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/jsonapi/v1/conversations",
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * Get conversation introduction
   * @param data The data for the request.
   * @param data.chapterId Current chapter
   * @param data.courseId Current course
   * @returns ConversationIntroduction Conversation response
   * @throws ApiError
   */
  public static getConversationIntroduction(
    data: GetConversationIntroductionData = {}
  ): CancelablePromise<GetConversationIntroductionResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/jsonapi/v1/conversations/introduction",
      query: {
        chapter_id: data.chapterId,
        course_id: data.courseId,
      },
    });
  }

  /**
   * Get conversations
   * @param data The data for the request.
   * @param data.id
   * @param data.deep include dependencies
   * @returns Conversation Conversation response
   * @throws ApiError
   */
  public static getConversation(
    data: GetConversationData
  ): CancelablePromise<GetConversationResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/jsonapi/v1/conversations/{id}",
      path: {
        id: data.id,
      },
      query: {
        deep: data.deep,
      },
    });
  }

  /**
   * Get conversation messages
   * @param data The data for the request.
   * @param data.id
   * @param data.sort Sort by id or -id
   * @param data.pageLimit Page size
   * @param data.pageOffset Page offset (multiple of page[limit])
   * @param data.deep include dependencies
   * @returns ConversationMessages Conversation messagesresponse
   * @throws ApiError
   */
  public static getConversationMessages(
    data: GetConversationMessagesData
  ): CancelablePromise<GetConversationMessagesResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/jsonapi/v1/conversations/{id}/messages",
      path: {
        id: data.id,
      },
      query: {
        sort: data.sort,
        "page[limit]": data.pageLimit,
        "page[offset]": data.pageOffset,
        deep: data.deep,
      },
    });
  }

  /**
   * Create a message in a conversation
   * @param data The data for the request.
   * @param data.id
   * @param data.requestBody Message attributes
   * @returns ConversationMessage Created message
   * @throws ApiError
   */
  public static createConversationMessage(
    data: CreateConversationMessageData
  ): CancelablePromise<CreateConversationMessageResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/jsonapi/v1/conversations/{id}/messages",
      path: {
        id: data.id,
      },
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * Create or update a message in a conversation (by message uuid)
   * @param data The data for the request.
   * @param data.id
   * @param data.requestBody Message attributes
   * @returns ConversationMessage Created or updated message
   * @throws ApiError
   */
  public static upsertConversationMessage(
    data: UpsertConversationMessageData
  ): CancelablePromise<UpsertConversationMessageResponse> {
    return __request(OpenAPI, {
      method: "PUT",
      url: "/jsonapi/v1/conversations/{id}/messages",
      path: {
        id: data.id,
      },
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * Get a message from a conversation
   * @param data The data for the request.
   * @param data.conversationId
   * @param data.id
   * @param data.deep include dependencies
   * @returns ConversationMessage Conversation response
   * @throws ApiError
   */
  public static getConversationMessage(
    data: GetConversationMessageData
  ): CancelablePromise<GetConversationMessageResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/jsonapi/v1/conversations/{conversation_id}/messages/{id}",
      path: {
        conversation_id: data.conversationId,
        id: data.id,
      },
      query: {
        deep: data.deep,
      },
    });
  }

  /**
   * Update a message from a conversation
   * @param data The data for the request.
   * @param data.conversationId
   * @param data.id
   * @param data.requestBody Message update attributes
   * @returns ConversationMessage Conversation message response
   * @throws ApiError
   */
  public static updateConversationMessage(
    data: UpdateConversationMessageData
  ): CancelablePromise<UpdateConversationMessageResponse> {
    return __request(OpenAPI, {
      method: "PATCH",
      url: "/jsonapi/v1/conversations/{conversation_id}/messages/{id}",
      path: {
        conversation_id: data.conversationId,
        id: data.id,
      },
      body: data.requestBody,
      mediaType: "application/json",
    });
  }
}

export class EmailConfirmationsService {
  /**
   * Create an Email Confirmation/Verification for the current user
   * @param data The data for the request.
   * @param data.requestBody Context for the Email Confirmation
   * @returns EmailConfirmation Email Confirmation sent to the email on file.
   * @throws ApiError
   */
  public static createEmailConfirmation(
    data: CreateEmailConfirmationData
  ): CancelablePromise<CreateEmailConfirmationResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/jsonapi/v1/email-confirmations",
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * Get a specific Email Confirmation/Verification
   * @param data The data for the request.
   * @param data.token Token that references a specific Email Confirmation
   * @returns EmailConfirmation Email Confirmation
   * @throws ApiError
   */
  public static getEmailConfirmation(
    data: GetEmailConfirmationData
  ): CancelablePromise<GetEmailConfirmationResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/jsonapi/v1/email-confirmations/{token}",
      path: {
        token: data.token,
      },
    });
  }

  /**
   * Get current email confirmation (legacy)
   * @returns unknown Email confirmation response
   * @throws ApiError
   */
  public static getLegacyEmailConfirmation(): CancelablePromise<GetLegacyEmailConfirmationResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/email_confirmations",
    });
  }

  /**
   * Send email confirmation
   * @param data The data for the request.
   * @param data.requestBody Email confirmation attributes
   * @returns unknown Email confirmation already exists
   * @throws ApiError
   */
  public static createLegacyEmailConfirmation(
    data: CreateLegacyEmailConfirmationData
  ): CancelablePromise<CreateLegacyEmailConfirmationResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/email_confirmations",
      body: data.requestBody,
      mediaType: "application/json",
      errors: {
        400: "Bad request",
      },
    });
  }
}

export class EnterpriseSubscriptionService {
  /**
   * download example CSV
   * @returns unknown CSV downloaded
   * @throws ApiError
   */
  public static downloadExampleCsv(): CancelablePromise<DownloadExampleCsvResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/jsonapi/v1/enterprise/enterprise_subscriptions/template",
      errors: {
        401: "Not authorized to download csv",
      },
    });
  }

  /**
   * Get Enterprise Subscriptions
   * @returns EnterpriseSubscriptions Enterprise Subscriptions list
   * @throws ApiError
   */
  public static getEnterpriseSubscriptions(): CancelablePromise<GetEnterpriseSubscriptionsResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/jsonapi/v1/enterprise/enterprise_subscriptions",
      errors: {
        401: "Not authorized to get enterprise subscriptions",
      },
    });
  }
}

export class NotificationsService {
  /**
   * Get notifications
   * @returns EnterpriseNotifications Notification list
   * @throws ApiError
   */
  public static getNotifications(): CancelablePromise<GetNotificationsResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/jsonapi/v1/enterprise/enterprise_notifications",
      errors: {
        401: "Not authorized to get notifications",
      },
    });
  }

  /**
   * Clear notifications
   * @param data The data for the request.
   * @param data.requestBody Ids to clear
   * @returns void Notifications deleted
   * @throws ApiError
   */
  public static clearNotifications(
    data: ClearNotificationsData
  ): CancelablePromise<ClearNotificationsResponse> {
    return __request(OpenAPI, {
      method: "PATCH",
      url: "/jsonapi/v1/enterprise/enterprise_notifications/clear",
      body: data.requestBody,
      mediaType: "application/json",
    });
  }
}

export class ScheduledInvitesService {
  /**
   * Get team's scheduled invitation detail
   * @param data The data for the request.
   * @param data.id Bulk import id
   * @returns TeamScheduledInvitation Scheduled invitation retrieved
   * @throws ApiError
   */
  public static getScheduledInvitation(
    data: GetScheduledInvitationData
  ): CancelablePromise<GetScheduledInvitationResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/jsonapi/v1/enterprise/bulk_send_invites/{id}",
      path: {
        id: data.id,
      },
      errors: {
        401: "Not authorized to get scheduled invitation",
      },
    });
  }

  /**
   * Update a scheduled invite
   * @param data The data for the request.
   * @param data.id
   * @param data.requestBody Scheduled invite attributes
   * @returns unknown Scheduled invite has been successfully updated
   * @throws ApiError
   */
  public static updateScheduledInvite(
    data: UpdateScheduledInviteData
  ): CancelablePromise<UpdateScheduledInviteResponse> {
    return __request(OpenAPI, {
      method: "PATCH",
      url: "/jsonapi/v1/enterprise/bulk_send_invites/{id}",
      path: {
        id: data.id,
      },
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * Cancels a scheduled invite
   * @param data The data for the request.
   * @param data.id
   * @returns void Scheduled invite has been successfully cancelled.
   * @throws ApiError
   */
  public static cancelScheduledInvite(
    data: CancelScheduledInviteData
  ): CancelablePromise<CancelScheduledInviteResponse> {
    return __request(OpenAPI, {
      method: "DELETE",
      url: "/jsonapi/v1/enterprise/bulk_send_invites/{id}",
      path: {
        id: data.id,
      },
    });
  }

  /**
   * Get team's scheduled invitation team members CSV
   * @param data The data for the request.
   * @param data.id Bulk invite ID
   * @param data.teamId team ID
   * @returns string Team's Scheduled invitations CSV retrieved
   * @throws ApiError
   */
  public static getScheduledInvitationCsv(
    data: GetScheduledInvitationCsvData
  ): CancelablePromise<GetScheduledInvitationCsvResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/jsonapi/v1/enterprise/bulk_send_invites/{id}/user_bulk_send_invites",
      path: {
        id: data.id,
      },
      query: {
        team_id: data.teamId,
      },
      errors: {
        401: "Not authorized to get Team's Scheduled invitations CSV",
      },
    });
  }
}

export class TeamService {
  /**
   * Create a new team
   * @param data The data for the request.
   * @param data.requestBody Attributes for the new Profile
   * @returns Team Team created successfully
   * @throws ApiError
   */
  public static createTeam(
    data: CreateTeamData
  ): CancelablePromise<CreateTeamResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/jsonapi/v1/enterprise/teams",
      body: data.requestBody,
      mediaType: "application/json",
      errors: {
        401: "Not authorized to create team",
      },
    });
  }

  /**
   * Get team info
   * @param data The data for the request.
   * @param data.id Team ID
   * @param data.include
   * @param data.pageOffset
   * @param data.filter
   * @returns Team Team data
   * @throws ApiError
   */
  public static getTeam(data: GetTeamData): CancelablePromise<GetTeamResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/jsonapi/v1/enterprise/teams/{id}",
      path: {
        id: data.id,
      },
      query: {
        include: data.include,
        "page[offset]": data.pageOffset,
        filter: data.filter,
      },
    });
  }

  /**
   * Delete an existing team
   * @param data The data for the request.
   * @param data.id Team ID
   * @returns unknown Team deleted
   * @throws ApiError
   */
  public static deleteTeam(
    data: DeleteTeamData
  ): CancelablePromise<DeleteTeamResponse> {
    return __request(OpenAPI, {
      method: "DELETE",
      url: "/jsonapi/v1/enterprise/teams/{id}",
      path: {
        id: data.id,
      },
      errors: {
        401: "Not authorized to delete team",
        404: "Team not found",
      },
    });
  }

  /**
   * Update team name
   * @param data The data for the request.
   * @param data.id Team ID
   * @param data.requestBody Team's new name
   * @returns unknown Team name updated
   * @throws ApiError
   */
  public static updateTeam(
    data: UpdateTeamData
  ): CancelablePromise<UpdateTeamResponse> {
    return __request(OpenAPI, {
      method: "PATCH",
      url: "/jsonapi/v1/enterprise/teams/{id}",
      path: {
        id: data.id,
      },
      body: data.requestBody,
      mediaType: "application/json",
      errors: {
        401: "Not authorized to update user",
        404: "Team not found",
      },
    });
  }

  /**
   * Create admin with new email
   * @param data The data for the request.
   * @param data.teamId Team ID
   * @param data.requestBody Email and role
   * @returns unknown New admin added
   * @throws ApiError
   */
  public static addAdminByEmail(
    data: AddAdminByEmailData
  ): CancelablePromise<AddAdminByEmailResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/jsonapi/v1/enterprise/teams/{team_id}/email",
      path: {
        team_id: data.teamId,
      },
      body: data.requestBody,
      mediaType: "application/json",
      errors: {
        401: "Unauthorized admin or requires a logged in user",
      },
    });
  }

  /**
   * Resend invite notification for user
   * @param data The data for the request.
   * @param data.teamId Team ID
   * @param data.userId User ID
   * @returns unknown Reminder sent
   * @throws ApiError
   */
  public static remindUser(
    data: RemindUserData
  ): CancelablePromise<RemindUserResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/jsonapi/v1/enterprise/teams/{team_id}/remind/{user_id}",
      path: {
        team_id: data.teamId,
        user_id: data.userId,
      },
      errors: {
        401: "Not authorized to remind user",
        404: "User not found",
      },
    });
  }

  /**
   * Update user's name
   * @param data The data for the request.
   * @param data.teamId Team ID
   * @param data.userId User ID
   * @param data.requestBody User's new name
   * @returns unknown User updated
   * @throws ApiError
   */
  public static updateTeamUser(
    data: UpdateTeamUserData
  ): CancelablePromise<UpdateTeamUserResponse> {
    return __request(OpenAPI, {
      method: "PATCH",
      url: "/jsonapi/v1/enterprise/teams/{team_id}/users/{user_id}",
      path: {
        team_id: data.teamId,
        user_id: data.userId,
      },
      body: data.requestBody,
      mediaType: "application/json",
      errors: {
        401: "Not authorized to update user",
        404: "User not found",
      },
    });
  }

  /**
   * Add user to team
   * @param data The data for the request.
   * @param data.teamId Team ID
   * @param data.userId User ID
   * @returns unknown User added to team
   * @throws ApiError
   */
  public static addUser(data: AddUserData): CancelablePromise<AddUserResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/jsonapi/v1/enterprise/teams/{team_id}/users/{user_id}",
      path: {
        team_id: data.teamId,
        user_id: data.userId,
      },
      errors: {
        401: "Not authorized to add user to team",
        404: "User not found",
      },
    });
  }

  /**
   * Remove user from team
   * @param data The data for the request.
   * @param data.teamId Team ID
   * @param data.userId User ID
   * @param data.role Admin Role
   * @returns unknown User removed from team
   * @throws ApiError
   */
  public static deleteUser(
    data: DeleteUserData
  ): CancelablePromise<DeleteUserResponse> {
    return __request(OpenAPI, {
      method: "DELETE",
      url: "/jsonapi/v1/enterprise/teams/{team_id}/users/{user_id}",
      path: {
        team_id: data.teamId,
        user_id: data.userId,
      },
      query: {
        role: data.role,
      },
      errors: {
        401: "Not authorized to remove user from team",
        404: "User not found",
      },
    });
  }

  /**
   * Add admin to team
   * @param data The data for the request.
   * @param data.teamId Team ID
   * @param data.userId User ID
   * @param data.role admin role
   * @returns unknown User added to team
   * @throws ApiError
   */
  public static addAdmin(
    data: AddAdminData
  ): CancelablePromise<AddAdminResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/jsonapi/v1/enterprise/teams/{team_id}/users/{user_id}/role/{role}",
      path: {
        team_id: data.teamId,
        user_id: data.userId,
        role: data.role,
      },
      errors: {
        401: "Not authorized to add user to team",
        404: "User not found",
      },
    });
  }

  /**
   * set admin's role
   * @param data The data for the request.
   * @param data.teamId Team ID
   * @param data.userId User ID
   * @param data.adminRole admin role
   * @returns unknown User updated
   * @throws ApiError
   */
  public static setAdminRole(
    data: SetAdminRoleData
  ): CancelablePromise<SetAdminRoleResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/jsonapi/v1/enterprise/teams/{team_id}/users/{user_id}/admin_role/{admin_role}",
      path: {
        team_id: data.teamId,
        user_id: data.userId,
        admin_role: data.adminRole,
      },
      errors: {
        401: "Not authorized to update user",
        404: "User not found",
      },
    });
  }

  /**
   * Get team's scheduled invitations
   * @param data The data for the request.
   * @param data.teamId Team ID
   * @returns TeamScheduledInvitations Scheduled invitations retrieved
   * @throws ApiError
   */
  public static getScheduledInvitations(
    data: GetScheduledInvitationsData
  ): CancelablePromise<GetScheduledInvitationsResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/jsonapi/v1/enterprise/teams/{team_id}/scheduled_invitations",
      path: {
        team_id: data.teamId,
      },
      errors: {
        401: "Not authorized to get scheduled invitations",
      },
    });
  }
}

export class OrganizationService {
  /**
   * Get organization info
   * @param data The data for the request.
   * @param data.id Organization ID
   * @param data.deep
   * @returns Organization Organization data
   * @throws ApiError
   */
  public static getOrganization(
    data: GetOrganizationData
  ): CancelablePromise<GetOrganizationResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/jsonapi/v1/enterprise/organizations/{id}",
      path: {
        id: data.id,
      },
      query: {
        deep: data.deep,
      },
    });
  }

  /**
   * removes the organization logo image
   * @param data The data for the request.
   * @param data.id Organization ID
   * @returns void Logo has been removed
   * @throws ApiError
   */
  public static removeLogo(
    data: RemoveLogoData
  ): CancelablePromise<RemoveLogoResponse> {
    return __request(OpenAPI, {
      method: "DELETE",
      url: "/jsonapi/v1/enterprise/organizations/{id}/logo",
      path: {
        id: data.id,
      },
    });
  }
}

export class CustomMessagingService {
  /**
   * Saves the organization custom message
   * @param data The data for the request.
   * @param data.requestBody Attributes for the custom message
   * @returns TeamNotification Custom message saved successfully
   * @throws ApiError
   */
  public static saveOrganizationMessage(
    data: SaveOrganizationMessageData
  ): CancelablePromise<SaveOrganizationMessageResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/jsonapi/v1/enterprise/team_notifications",
      body: data.requestBody,
      mediaType: "application/json",
      errors: {
        401: "Not authorized to add custom message",
      },
    });
  }

  /**
   * gets the organization custom message given by id
   * @param data The data for the request.
   * @param data.id Team notification ID
   * @returns TeamNotification Custom message retrieved
   * @throws ApiError
   */
  public static getOrganizationMessage(
    data: GetOrganizationMessageData
  ): CancelablePromise<GetOrganizationMessageResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/jsonapi/v1/enterprise/team_notifications/{id}",
      path: {
        id: data.id,
      },
      errors: {
        401: "Not authorized to get organization custom message",
      },
    });
  }

  /**
   * Deletes the organization custom message
   * @param data The data for the request.
   * @param data.id Team notification ID
   * @returns void Organization Custom Message has been deleted
   * @throws ApiError
   */
  public static deleteOrganizationMessage(
    data: DeleteOrganizationMessageData
  ): CancelablePromise<DeleteOrganizationMessageResponse> {
    return __request(OpenAPI, {
      method: "DELETE",
      url: "/jsonapi/v1/enterprise/team_notifications/{id}",
      path: {
        id: data.id,
      },
      errors: {
        401: "Not authorized to delete organization custom message",
      },
    });
  }

  /**
   * Dismisses the organization custom message for the current user
   * @param data The data for the request.
   * @param data.id Team notification ID
   * @returns unknown Organization Custom Message has been dismissed for the current user
   * @throws ApiError
   */
  public static dismissOrganizationMessage(
    data: DismissOrganizationMessageData
  ): CancelablePromise<DismissOrganizationMessageResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/jsonapi/v1/enterprise/team_notifications/{id}/dismiss",
      path: {
        id: data.id,
      },
      errors: {
        401: "Not authorized to dismiss the organization custom message",
      },
    });
  }

  /**
   * gets the organization member available custom message
   * @returns MemberNotification Custom message retrieved
   * @throws ApiError
   */
  public static getUnreadOrganizationMessage(): CancelablePromise<GetUnreadOrganizationMessageResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/jsonapi/v1/enterprise/my_notifications/unread",
      errors: {
        401: "Not authorized to get organization member custom message",
      },
    });
  }
}

export class EpisodesV1Service {
  /**
   * Gets all episodes with filter options
   * @param data The data for the request.
   * @param data.deep include dependencies
   * @param data.filter Filters for Episodes
   * @returns Episodes List of all Episodes filtered by options
   * @throws ApiError
   */
  public static getEpisodes(
    data: GetEpisodesData = {}
  ): CancelablePromise<GetEpisodesResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/jsonapi/v1/episodes",
      query: {
        deep: data.deep,
        filter: data.filter,
      },
    });
  }

  /**
   * Get Episode by slug
   * @param data The data for the request.
   * @param data.slug Episode slug
   * @param data.deep include dependencies
   * @returns Episode Episode response
   * @throws ApiError
   */
  public static getEpisodeBySlug(
    data: GetEpisodeBySlugData
  ): CancelablePromise<GetEpisodeBySlugResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/jsonapi/v1/episodes/{slug}",
      path: {
        slug: data.slug,
      },
      query: {
        deep: data.deep,
      },
    });
  }
}

export class ExperimentsService {
  /**
   * Get experiments
   * @returns Experiments Array of experiments
   * @throws ApiError
   */
  public static getExperiments(): CancelablePromise<GetExperimentsResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/jsonapi/v1/experiments/sessionless",
    });
  }
}

export class FeatureInteractionsService {
  /**
   * Get list of all Feature Interactions
   * @param data The data for the request.
   * @param data.filter Filters for current user's Feature Interactions
   * @returns FeatureInteractionsResult List of feature interactions
   * @throws ApiError
   */
  public static getFeatureInteractions(
    data: GetFeatureInteractionsData = {}
  ): CancelablePromise<GetFeatureInteractionsResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/jsonapi/v1/feature-interactions",
      query: {
        filter: data.filter,
      },
    });
  }

  /**
   * Create/Update a Feature Interaction
   * @param data The data for the request.
   * @param data.requestBody Updated feature interaction info
   * @returns FeatureInteraction Successful create/update of Feature Interaction
   * @throws ApiError
   */
  public static updateFeatureInteraction(
    data: UpdateFeatureInteractionData
  ): CancelablePromise<UpdateFeatureInteractionResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/jsonapi/v1/feature-interactions",
      body: data.requestBody,
      mediaType: "application/json",
    });
  }
}

export class FreeTrialService {
  /**
   * Get Free Trial data
   * @param data The data for the request.
   * @param data.referralToken Referral token
   * @returns FreeTrial free trial data
   * @throws ApiError
   */
  public static getGuestPasses(
    data: GetGuestPassesData
  ): CancelablePromise<GetGuestPassesResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/jsonapi/v1/guest-passes/{referralToken}",
      path: {
        referralToken: data.referralToken,
      },
    });
  }
}

export class GuestPassShareService {
  /**
   * Track guest pass share via email
   * @param data The data for the request.
   * @param data.requestBody Emails where the guest pass will be shared
   * @returns unknown Fire events for emails
   * @throws ApiError
   */
  public static sendGuestPassViaEmail(
    data: SendGuestPassViaEmailData
  ): CancelablePromise<SendGuestPassViaEmailResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/jsonapi/v1/guest-pass-email-share",
      body: data.requestBody,
      mediaType: "application/json",
    });
  }
}

export class ImmersiveHerosService {
  /**
   * Get immersive heros
   * @param data The data for the request.
   * @param data.deep include dependencies
   * @param data.filter specify a one of slug, course_slug, or chapter_slug to filter
   * @returns ImmersiveHeros Immersive Heroes response
   * @throws ApiError
   */
  public static getImmersiveHeros(
    data: GetImmersiveHerosData = {}
  ): CancelablePromise<GetImmersiveHerosResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/jsonapi/v1/immersive-heros",
      query: {
        deep: data.deep,
        filter: data.filter,
      },
    });
  }
}

export class InstructorsV1Service {
  /**
   * Get instructors
   * @param data The data for the request.
   * @param data.deep include dependencies
   * @param data.filter
   * @returns Instructor List of instructors
   * @throws ApiError
   */
  public static getInstructors(
    data: GetInstructorsData = {}
  ): CancelablePromise<GetInstructorsResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/jsonapi/v1/instructors",
      query: {
        deep: data.deep,
        filter: data.filter,
      },
      errors: {
        401: "User is not signed in",
      },
    });
  }
}

export class NotesV1Service {
  /**
   * Get list of the current user's notes
   * @param data The data for the request.
   * @param data.deep include dependencies
   * @param data.filter Filters for Notes
   * @returns Notes List of notes
   * @throws ApiError
   */
  public static getNotes(
    data: GetNotesData = {}
  ): CancelablePromise<GetNotesResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/jsonapi/v1/notes",
      query: {
        deep: data.deep,
        filter: data.filter,
      },
    });
  }

  /**
   * Create a note
   * @param data The data for the request.
   * @param data.requestBody Note attributes
   * @returns Note Created note
   * @throws ApiError
   */
  public static createNote(
    data: CreateNoteData
  ): CancelablePromise<CreateNoteResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/jsonapi/v1/notes",
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * Delete a note
   * @param data The data for the request.
   * @param data.id
   * @returns void Note is deleted
   * @throws ApiError
   */
  public static deleteNote(
    data: DeleteNoteData
  ): CancelablePromise<DeleteNoteResponse> {
    return __request(OpenAPI, {
      method: "DELETE",
      url: "/jsonapi/v1/notes/{id}",
      path: {
        id: data.id,
      },
    });
  }

  /**
   * Update a note
   * @param data The data for the request.
   * @param data.id
   * @param data.requestBody Note attributes
   * @returns Note Updated note
   * @throws ApiError
   */
  public static updateNote(
    data: UpdateNoteData
  ): CancelablePromise<UpdateNoteResponse> {
    return __request(OpenAPI, {
      method: "PATCH",
      url: "/jsonapi/v1/notes/{id}",
      path: {
        id: data.id,
      },
      body: data.requestBody,
      mediaType: "application/json",
    });
  }
}

export class PlaylistsService {
  /**
   * Get playlists
   * @param data The data for the request.
   * @param data.slug
   * @param data.deep include dependencies
   * @param data.track
   * @returns Playlist Playlist response
   * @throws ApiError
   */
  public static getPlaylist(
    data: GetPlaylistData
  ): CancelablePromise<GetPlaylistResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/jsonapi/v1/playlists/{slug}",
      path: {
        slug: data.slug,
      },
      query: {
        deep: data.deep,
        track: data.track,
      },
    });
  }

  /**
   * Get playlists
   * @param data The data for the request.
   * @param data.deep include dependencies
   * @param data.filter
   * @returns Playlists Playlists response
   * @throws ApiError
   */
  public static getPlaylists(
    data: GetPlaylistsData = {}
  ): CancelablePromise<GetPlaylistsResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/jsonapi/v1/playlists",
      query: {
        deep: data.deep,
        filter: data.filter,
      },
    });
  }
}

export class ProductsService {
  /**
   * Get products
   * @param data The data for the request.
   * @param data.filterPurchasePlanSlugs include additional dependencies
   * @param data.gift gift query param, determines whether we are sending a gift or not
   * @param data.discountSlug discount slug query param, if sent the endpoint will respond the product with discounted prices applied
   * @returns Products Products response
   * @throws ApiError
   */
  public static getProducts(
    data: GetProductsData = {}
  ): CancelablePromise<GetProductsResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/jsonapi/v1/products",
      query: {
        "filter[purchase_plan_slugs]": data.filterPurchasePlanSlugs,
        gift: data.gift,
        discount_slug: data.discountSlug,
      },
    });
  }
}

export class ProfileService {
  /**
   * Gets all profiles for the current user
   * @param data The data for the request.
   * @param data.deep include dependencies
   * @returns Profiles List of all Profiles associated to the current User
   * @throws ApiError
   */
  public static getProfiles(
    data: GetProfilesData = {}
  ): CancelablePromise<GetProfilesResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/jsonapi/v1/profiles",
      query: {
        deep: data.deep,
      },
    });
  }

  /**
   * Create a new Profile for the current user
   * @param data The data for the request.
   * @param data.requestBody Attributes for the new Profile
   * @param data.deep include dependencies
   * @returns Profile Newly created Profile
   * @throws ApiError
   */
  public static createProfile(
    data: CreateProfileData
  ): CancelablePromise<CreateProfileResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/jsonapi/v1/profiles",
      query: {
        deep: data.deep,
      },
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * Gets a Profile by the given id
   * @param data The data for the request.
   * @param data.id Profile ID
   * @param data.deep include dependencies
   * @returns Profile The profile uniquely identified by the given id
   * @throws ApiError
   */
  public static getProfile(
    data: GetProfileData
  ): CancelablePromise<GetProfileResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/jsonapi/v1/profiles/{id}",
      path: {
        id: data.id,
      },
      query: {
        deep: data.deep,
      },
    });
  }

  /**
   * Update a Profile with new information
   * @param data The data for the request.
   * @param data.id
   * @param data.requestBody Profile attributes to be changed
   * @param data.deep include dependencies
   * @returns Profile The updated Profile
   * @throws ApiError
   */
  public static updateProfile(
    data: UpdateProfileData
  ): CancelablePromise<UpdateProfileResponse> {
    return __request(OpenAPI, {
      method: "PATCH",
      url: "/jsonapi/v1/profiles/{id}",
      path: {
        id: data.id,
      },
      query: {
        deep: data.deep,
      },
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * Deletes a Profile by the given id
   * @param data The data for the request.
   * @param data.id
   * @returns void Profile is deleted
   * @throws ApiError
   */
  public static deleteProfile(
    data: DeleteProfileData
  ): CancelablePromise<DeleteProfileResponse> {
    return __request(OpenAPI, {
      method: "DELETE",
      url: "/jsonapi/v1/profiles/{id}",
      path: {
        id: data.id,
      },
    });
  }
}

export class OnboardingContentRecommendationService {
  /**
   * It fetches a list of courses and camps ordered by the engagement_rank attribute.
   * @returns OnboardingContentRecommendation Onboarding content recommendation response
   * @throws ApiError
   */
  public static getOnboardingContentRecommendation(): CancelablePromise<GetOnboardingContentRecommendationResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/jsonapi/v1/onboarding-content-recommendation",
    });
  }
}

export class PurchasePlanService {
  /**
   * Get purchase plan
   * @param data The data for the request.
   * @param data.id Either id number or specific plan slug
   * @param data.deep include dependencies
   * @returns PurchasePlan Purchase plan data
   * @throws ApiError
   */
  public static getPurchasePlan(
    data: GetPurchasePlanData
  ): CancelablePromise<GetPurchasePlanResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/jsonapi/v1/purchase_plans/{id}",
      path: {
        id: data.id,
      },
      query: {
        deep: data.deep,
      },
    });
  }
}

export class ReferralAudioProgramsService {
  /**
   * Get list of referral audio programs
   * @returns ReferralAudioProgramsResult List of showcase items
   * @throws ApiError
   */
  public static getReferralAudioPrograms(): CancelablePromise<GetReferralAudioProgramsResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/jsonapi/v1/referral-audio-programs",
    });
  }
}

export class ReferralTokensService {
  /**
   * Create Guest Pass invitation links
   * @param data The data for the request.
   * @param data.requestBody Attributes to create an invitation link. These attributes will be used to create utm params and handle link redirection
   * @returns ShareLinks Created invitation links
   * @throws ApiError
   */
  public static createShareableGuestPassLinks(
    data: CreateShareableGuestPassLinksData
  ): CancelablePromise<CreateShareableGuestPassLinksResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/jsonapi/v1/referral-tokens",
      body: data.requestBody,
      mediaType: "application/json",
    });
  }
}

export class ShowcaseService {
  /**
   * Get list of showcases
   * @param data The data for the request.
   * @param data.deep include dependencies
   * @returns ShowcasesResult List of showcase items
   * @throws ApiError
   */
  public static getShowcases(
    data: GetShowcasesData = {}
  ): CancelablePromise<GetShowcasesResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/jsonapi/v1/showcases",
      query: {
        deep: data.deep,
      },
    });
  }
}

export class SkillsService {
  /**
   * Get list of library skills
   * @returns SkillsResult List of skills
   * @throws ApiError
   */
  public static getSkills(): CancelablePromise<GetSkillsResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/jsonapi/v1/skills",
    });
  }
}

export class LastUserSubscriptionV1Service {
  /**
   * Gets the last user subscription
   * @param data The data for the request.
   * @param data.deep include dependencies
   * @returns Subscription The subscription item
   * @throws ApiError
   */
  public static getLastUserSubscription(
    data: GetLastUserSubscriptionData = {}
  ): CancelablePromise<GetLastUserSubscriptionResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/jsonapi/v1/subscriptions/last",
      query: {
        deep: data.deep,
      },
    });
  }
}

export class PlaylistThemesService {
  /**
   * Get playlist themes
   * @param data The data for the request.
   * @param data.filter Filters for ids
   * @param data.include include additional dependencies
   * @param data.deep include dependencies
   * @returns ThemesResults Themes response
   * @throws ApiError
   */
  public static getThemes(
    data: GetThemesData = {}
  ): CancelablePromise<GetThemesResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/jsonapi/v1/themes",
      query: {
        filter: data.filter,
        include: data.include,
        deep: data.deep,
      },
    });
  }
}

export class TiersService {
  /**
   * List user current tiers or default tiers
   * @param data The data for the request.
   * @param data.deep include dependencies
   * @param data.gift gift query param, determines whether we are sending a gift or not
   * @param data.discountSlug discount slug query param, if sent the endpoint will respond the product with discounted prices applied
   * @param data.collapsedBucket temporal param to support the prcng-107_v1 experiment and return the correct tier collection
   * @returns TierCollection Tiers response
   * @throws ApiError
   */
  public static getCurrentTierCollection(
    data: GetCurrentTierCollectionData = {}
  ): CancelablePromise<GetCurrentTierCollectionResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/jsonapi/v1/tier_collections/current",
      query: {
        deep: data.deep,
        gift: data.gift,
        discount_slug: data.discountSlug,
        collapsed_bucket: data.collapsedBucket,
      },
    });
  }

  /**
   * List persona bundle tier collection
   * @param data The data for the request.
   * @param data.deep include dependencies
   * @param data.gift gift query param, determines whether we are sending a gift or not
   * @param data.discountSlug discount slug query param, if sent the endpoint will respond the product with discounted prices applied
   * @returns TierCollection Tiers response
   * @throws ApiError
   */
  public static getPersonaBundleTierCollection(
    data: GetPersonaBundleTierCollectionData = {}
  ): CancelablePromise<GetPersonaBundleTierCollectionResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/jsonapi/v1/tier_collections/persona-bundle",
      query: {
        deep: data.deep,
        gift: data.gift,
        discount_slug: data.discountSlug,
      },
    });
  }
}

export class UserCartDataService {
  /**
   * Get user cart data
   * @param data The data for the request.
   * @param data.deep include dependencies
   * @returns CartData User cart data
   * @throws ApiError
   */
  public static getUserCartData(
    data: GetUserCartDataData = {}
  ): CancelablePromise<GetUserCartDataResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/jsonapi/v1/user/cart-data",
      query: {
        deep: data.deep,
      },
    });
  }
}

export class GuestPassesService {
  /**
   * Get user guest passes
   * @returns GuestPass User guest passes data
   * @throws ApiError
   */
  public static getUserGuestPasses(): CancelablePromise<GetUserGuestPassesResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/jsonapi/v1/user/guest-passes",
    });
  }
}

export class UserProductsV1Service {
  /**
   * Get Product for last user subscription
   * @returns Product Product response
   * @throws ApiError
   */
  public static getLastUserProduct(): CancelablePromise<GetLastUserProductResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/jsonapi/v1/user/products/last",
      errors: {
        401: "User is not signed in",
        404: "User has no subscription with a product",
      },
    });
  }
}

export class StreamsService {
  /**
   * Validate current streaming session or start a new one
   * @param data The data for the request.
   * @param data.requestBody Information about a new streaming session
   * @returns StreamsResult Streaming session information is received
   * @throws ApiError
   */
  public static validateStreamConcurrency(
    data: ValidateStreamConcurrencyData
  ): CancelablePromise<ValidateStreamConcurrencyResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/jsonapi/v1/user/streams",
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * Request to destroy the client streaming session
   * @param data The data for the request.
   * @param data.requestBody Streaming session id
   * @returns StreamsResult Streaming session is destroyed
   * @throws ApiError
   */
  public static releaseConcurrentSeat(
    data: ReleaseConcurrentSeatData
  ): CancelablePromise<ReleaseConcurrentSeatResponse> {
    return __request(OpenAPI, {
      method: "DELETE",
      url: "/jsonapi/v1/user/streams",
      body: data.requestBody,
      mediaType: "application/json",
    });
  }
}

export class UserSessionsService {
  /**
   * Get user sessions
   * @returns UserSessionsResult User sessions response
   * @throws ApiError
   */
  public static getUserSessions(): CancelablePromise<GetUserSessionsResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/jsonapi/v1/user-camps",
    });
  }
}

export class UserCoursesService {
  /**
   * Get user courses
   * @param data The data for the request.
   * @param data.include include additional dependencies
   * @param data.deep include dependencies
   * @returns UserCoursesResult User courses response
   * @throws ApiError
   */
  public static getUserCourses(
    data: GetUserCoursesData = {}
  ): CancelablePromise<GetUserCoursesResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/jsonapi/v1/user-courses",
      query: {
        include: data.include,
        deep: data.deep,
      },
    });
  }

  /**
   * Create a User Course
   * @param data The data for the request.
   * @param data.requestBody Course to associate to User
   * @param data.deep include dependencies
   * @returns UserCourse Created User Course
   * @throws ApiError
   */
  public static createUserCourse(
    data: CreateUserCourseData
  ): CancelablePromise<CreateUserCourseResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/jsonapi/v1/user-courses",
      query: {
        deep: data.deep,
      },
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * Get user course
   * @param data The data for the request.
   * @param data.slug Course slug
   * @param data.filter Filters courses by tag
   * @param data.deep include dependencies
   * @returns UserCourse User course response
   * @throws ApiError
   */
  public static getUserCourseBySlug(
    data: GetUserCourseBySlugData
  ): CancelablePromise<GetUserCourseBySlugResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/jsonapi/v1/user-courses/{slug}",
      path: {
        slug: data.slug,
      },
      query: {
        filter: data.filter,
        deep: data.deep,
      },
    });
  }
}

export class UserProgressService {
  /**
   * Get user progress entries
   * @param data The data for the request.
   * @param data.filter Filters for current user's watch list items
   * @returns UserProgressResults User progress response
   * @throws ApiError
   */
  public static getUserProgress(
    data: GetUserProgressData = {}
  ): CancelablePromise<GetUserProgressResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/jsonapi/v1/user-progress",
      query: {
        filter: data.filter,
      },
    });
  }
}

export class UserPlaylistsService {
  /**
   * Get user playlist entries
   * @param data The data for the request.
   * @param data.filter Filters for completed playlists
   * @param data.include include additional dependencies
   * @param data.deep include dependencies
   * @returns UserPlaylistResults User playlists response
   * @throws ApiError
   */
  public static getUserPlaylists(
    data: GetUserPlaylistsData = {}
  ): CancelablePromise<GetUserPlaylistsResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/jsonapi/v1/user-playlists",
      query: {
        filter: data.filter,
        include: data.include,
        deep: data.deep,
      },
    });
  }
}

export class UserService {
  /**
   * Get user data
   * @param data The data for the request.
   * @param data.id User id
   * @param data.deep include dependencies
   * @returns User User data
   * @throws ApiError
   */
  public static getUser(data: GetUserData): CancelablePromise<GetUserResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/jsonapi/v1/users/{id}",
      path: {
        id: data.id,
      },
      query: {
        deep: data.deep,
      },
    });
  }

  /**
   * Update user
   * @param data The data for the request.
   * @param data.id User id
   * @param data.requestBody Updated user info
   * @returns User Successful update of user
   * @throws ApiError
   */
  public static updateUser(
    data: UpdateUserData
  ): CancelablePromise<UpdateUserResponse> {
    return __request(OpenAPI, {
      method: "PATCH",
      url: "/jsonapi/v1/users/{id}",
      path: {
        id: data.id,
      },
      body: data.requestBody,
      mediaType: "application/json",
    });
  }
}

export class VideoProgressEntriesV1Service {
  /**
   * Get Video Progress Entries
   * @param data The data for the request.
   * @param data.filter Filters for current user's Video Progress Entries
   * @returns VideoProgressEntriesResult Video Progress Entries for current user
   * @throws ApiError
   */
  public static getVideoProgressEntries(
    data: GetVideoProgressEntriesData = {}
  ): CancelablePromise<GetVideoProgressEntriesResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/jsonapi/v1/video-progress-entries",
      query: {
        filter: data.filter,
      },
    });
  }

  /**
   * Create new Video Progress Entry
   * @param data The data for the request.
   * @param data.requestBody New video progress entry info
   * @returns VideoProgressEntry Successful create of Video Progress Entry
   * @throws ApiError
   */
  public static createVideoProgressEntry(
    data: CreateVideoProgressEntryData
  ): CancelablePromise<CreateVideoProgressEntryResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/jsonapi/v1/video-progress-entries",
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * Update Video Progress Entry
   * @param data The data for the request.
   * @param data.id Video Progress Entry id
   * @param data.requestBody Updated video progress entry info
   * @returns VideoProgressEntry Successful update of Video Progress Entry
   * @throws ApiError
   */
  public static updateVideoProgressEntry(
    data: UpdateVideoProgressEntryData
  ): CancelablePromise<UpdateVideoProgressEntryResponse> {
    return __request(OpenAPI, {
      method: "PATCH",
      url: "/jsonapi/v1/video-progress-entries/{id}",
      path: {
        id: data.id,
      },
      body: data.requestBody,
      mediaType: "application/json",
    });
  }
}

export class WatchListItemsService {
  /**
   * Gets the current items in the watch list
   * @param data The data for the request.
   * @param data.deep include dependencies
   * @returns WatchListResults Watch list items response
   * @throws ApiError
   */
  public static getWatchListItems(
    data: GetWatchListItemsData = {}
  ): CancelablePromise<GetWatchListItemsResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/jsonapi/v1/watch-list-items",
      query: {
        deep: data.deep,
      },
    });
  }

  /**
   * Add an item for the current user's watch list with the specified parameters
   * @param data The data for the request.
   * @param data.requestBody Information about the watch list item
   * @returns WatchListItem Successful create of Watch List Item
   * @throws ApiError
   */
  public static createWatchListItem(
    data: CreateWatchListItemData
  ): CancelablePromise<CreateWatchListItemResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/jsonapi/v1/watch-list-items",
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * Removes the item from the use's watch list
   * @param data The data for the request.
   * @param data.id Id of the current item
   * @returns unknown The item is removed
   * @throws ApiError
   */
  public static deleteWatchListItem(
    data: DeleteWatchListItemData
  ): CancelablePromise<DeleteWatchListItemResponse> {
    return __request(OpenAPI, {
      method: "DELETE",
      url: "/jsonapi/v1/watch-list-items/{id}",
      path: {
        id: data.id,
      },
    });
  }
}

export class LandingPricesService {
  /**
   * Get painted door landing prices
   * @param data The data for the request.
   * @param data.mcGeo user geo to calculate price
   * @returns LandingPrices Prices response
   * @throws ApiError
   */
  public static getLandingPrices(
    data: GetLandingPricesData
  ): CancelablePromise<GetLandingPricesResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/jsonapi/v1/products/landing-prices",
      query: {
        mc_geo: data.mcGeo,
      },
    });
  }
}

export class PersonaBundleService {
  /**
   * Get persona bundle pricing information
   * @returns PersonaBundle Persona bundle pricing information response
   * @throws ApiError
   */
  public static getPersonaBundle(): CancelablePromise<GetPersonaBundleResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/jsonapi/v1/products/persona-bundle",
    });
  }
}

export class SearchConfigService {
  /**
   * Get Algolia search configuration
   * @param data The data for the request.
   * @param data.mode
   * @param data.userExperience
   * @param data.platform
   * @returns SearchConfig Algolia search configuration
   * @throws ApiError
   */
  public static getSearchConfig(
    data: GetSearchConfigData = {}
  ): CancelablePromise<GetSearchConfigResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/jsonapi/v2/search-config",
      query: {
        mode: data.mode,
        user_experience: data.userExperience,
        platform: data.platform,
      },
    });
  }
}

export class AccountService {
  /**
   * Retrieve if email already exists in the database
   * @param data The data for the request.
   * @param data.email email to verify
   * @returns EmailAccount Email is registered (User already exists)
   * @throws ApiError
   */
  public static getRegisteredEmail(
    data: GetRegisteredEmailData
  ): CancelablePromise<GetRegisteredEmailResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/v1/accounts/check_email",
      query: {
        email: data.email,
      },
      errors: {
        404: "Email is not registered (User does not exists)",
      },
    });
  }

  /**
   * Set name and password for current user
   * @param data The data for the request.
   * @param data.requestBody User attributes
   * @returns unknown User name and password are set correctly
   * @throws ApiError
   */
  public static completeUserRegistration(
    data: CompleteUserRegistrationData
  ): CancelablePromise<CompleteUserRegistrationResponse> {
    return __request(OpenAPI, {
      method: "PUT",
      url: "/api/v1/accounts/complete_registration",
      body: data.requestBody,
      mediaType: "application/json",
    });
  }
}

export class CreditCardsService {
  /**
   * Create an Credit Card for the current user
   * @param data The data for the request.
   * @param data.requestBody Credit card params
   * @returns CreditCard Credit card created
   * @throws ApiError
   */
  public static addCreditCard(
    data: AddCreditCardData
  ): CancelablePromise<AddCreditCardResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/v1/credit_cards",
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * Retrieve the list of Credit Cards for the current user
   * @returns CreditCards Credit cards index
   * @throws ApiError
   */
  public static getCreditCards(): CancelablePromise<GetCreditCardsResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/v1/credit_cards",
    });
  }

  /**
   * Deletes a Credit Card by the given id
   * @param data The data for the request.
   * @param data.id
   * @returns void Credit card is deleted
   * @throws ApiError
   */
  public static removeCreditCard(
    data: RemoveCreditCardData
  ): CancelablePromise<RemoveCreditCardResponse> {
    return __request(OpenAPI, {
      method: "DELETE",
      url: "/api/v1/credit_cards/{id}",
      path: {
        id: data.id,
      },
    });
  }

  /**
   * Retrieve the list of Credit Cards with user ip currency for the current user
   * @param data The data for the request.
   * @param data.tokenOnly Filter credit card by payment method cards or token cards
   * @returns CreditCards Credit cards with user ip currency index
   * @throws ApiError
   */
  public static getCreditCardsWithCurrency(
    data: GetCreditCardsWithCurrencyData = {}
  ): CancelablePromise<GetCreditCardsWithCurrencyResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/v1/credit_cards/credit_cards_with_currency",
      query: {
        token_only: data.tokenOnly,
      },
    });
  }

  /**
   * Retrieve the default Credit Card for the current user
   * @returns CreditCard Default credit card
   * @throws ApiError
   */
  public static getDefaultCreditCard(): CancelablePromise<GetDefaultCreditCardResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/v1/credit_cards/default_credit_card",
    });
  }

  /**
   * Check the status of a setup intent
   * @param data The data for the request.
   * @param data.setupIntentId
   * @returns unknown Returns either a status object or credit card details. A status object is returned while the setup intent is pending confirmation. Once confirmed, the complete credit card details are returned.
   * @throws ApiError
   */
  public static checkSetupIntentStatus(
    data: CheckSetupIntentStatusData
  ): CancelablePromise<CheckSetupIntentStatusResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/v1/credit_cards/confirm",
      query: {
        setup_intent_id: data.setupIntentId,
      },
    });
  }
}

export class CouponsService {
  /**
   * Verify if a coupon exists or is valid
   * @param data The data for the request.
   * @param data.code Slug of the coupon to be verified
   * @param data.productId ID of the product the coupon is being applied to
   * @returns DiscountCoupon Coupon details
   * @throws ApiError
   */
  public static verifyCoupon(
    data: VerifyCouponData
  ): CancelablePromise<VerifyCouponResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/v1/coupons/verify",
      query: {
        code: data.code,
        product_id: data.productId,
      },
    });
  }
}

export class OrdersService {
  /**
   * Create an order & purchase a product for the current user
   * @param data The data for the request.
   * @param data.xTsBucket COM-839
   * @param data.requestBody Order params
   * @returns Order Purchase completed
   * @throws ApiError
   */
  public static createOrder(
    data: CreateOrderData
  ): CancelablePromise<CreateOrderResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/v2/orders",
      headers: {
        "X-TS-Bucket": data.xTsBucket,
      },
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * For Afterpay; confirm if the order is completed or in the pending state
   * @param data The data for the request.
   * @param data.id
   * @returns OrderConfirmation Order status retrieved
   * @throws ApiError
   */
  public static confirm(data: ConfirmData): CancelablePromise<ConfirmResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/v2/orders/{id}/confirm",
      path: {
        id: data.id,
      },
    });
  }
}

export class CartsService {
  /**
   * Add discount to product in cart
   * @param data The data for the request.
   * @param data.requestBody Send the product_id and discount we would like to add
   * @returns unknown Cart product updated successfully
   * @throws ApiError
   */
  public static addDiscountToCartProducts(
    data: AddDiscountToCartProductsData
  ): CancelablePromise<AddDiscountToCartProductsResponse> {
    return __request(OpenAPI, {
      method: "PUT",
      url: "/api/v2/cart",
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * Add selected product to cart
   * @param data The data for the request.
   * @param data.requestBody Cart attributes
   * @returns unknown Product added successfully
   * @throws ApiError
   */
  public static addProductToCart(
    data: AddProductToCartData
  ): CancelablePromise<AddProductToCartResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/v2/cart/add_product",
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * Clear all products from the cart
   * @returns unknown Cart cleared successfully
   * @throws ApiError
   */
  public static clearCart(): CancelablePromise<ClearCartResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/v2/cart/clear_cart",
    });
  }

  /**
   * Remove selected product from cart
   * @param data The data for the request.
   * @param data.requestBody Product attributes
   * @returns unknown Product removed successfully
   * @throws ApiError
   */
  public static removeProductFromCart(
    data: RemoveProductFromCartData
  ): CancelablePromise<RemoveProductFromCartResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/v2/cart/remove_product",
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * Returns a list of products added to cart
   * @param data The data for the request.
   * @param data.gift if user is gifting, we send gift = true
   * @returns CartProducts List of all products added
   * @throws ApiError
   */
  public static getCartProducts(
    data: GetCartProductsData = {}
  ): CancelablePromise<GetCartProductsResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/v2/cart/show_products",
      query: {
        gift: data.gift,
      },
    });
  }
}

export class BogoGiftsService {
  /**
   * Send BOGO gift to someone
   * @param data The data for the request.
   * @param data.bogoGiftToken gift token
   * @param data.requestBody Gift attributes
   * @returns unknown Gift sent correctly
   * @throws ApiError
   */
  public static redeem(data: RedeemData): CancelablePromise<RedeemResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/bogo_gifts/{bogo_gift_token}/redeem",
      path: {
        bogo_gift_token: data.bogoGiftToken,
      },
      body: data.requestBody,
      mediaType: "application/json",
    });
  }
}

export class UsersService {
  /**
   * Returns promo details of gift add-on from active subscription
   * @returns GiftAddOn Discount details for purchase a gift add on subscription
   * @throws ApiError
   */
  public static getGiftAddOn(): CancelablePromise<GetGiftAddOnResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/v2/users/gift_add_on",
      errors: {
        401: "No user logged in to the system",
      },
    });
  }
}

export class AddOnsService {
  /**
   * Returns details of all add-ons.
   * @returns unknown Details required for the add ons storefront page
   * @throws ApiError
   */
  public static getAddOns(): CancelablePromise<GetAddOnsResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/v2/add_ons",
    });
  }

  /**
   * Returns details of the learning toolkit add-on.
   * @returns LearningToolkitAddOn Details needed for purchase of a learning toolkit subscription
   * @throws ApiError
   */
  public static getLearningToolkitAddOn(): CancelablePromise<GetLearningToolkitAddOnResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/v2/add_ons/learning_toolkit",
    });
  }

  /**
   * Returns details of the persona add-on.
   * @returns PersonaAddOn Details needed for purchase of a persona add-on subscription
   * @throws ApiError
   */
  public static getPersonaAddOn(): CancelablePromise<GetPersonaAddOnResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/v2/add_ons/persona",
    });
  }

  /**
   * Returns proration preview for an add-on product.
   * @param data The data for the request.
   * @param data.id ID of the product to preview proration for
   * @returns ProrationPreview Proration preview information for the specified product
   * @throws ApiError
   */
  public static previewProration(
    data: PreviewProrationData
  ): CancelablePromise<PreviewProrationResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/v2/add_ons/{id}/preview_proration",
      path: {
        id: data.id,
      },
      errors: {
        404: "Product not found",
      },
    });
  }
}

export class AddOnSubscriptionsService {
  /**
   * cancel an add on subscription renewal
   * @param data The data for the request.
   * @param data.id
   * @returns unknown Add on Subscription will not be renewed
   * @throws ApiError
   */
  public static cancel(data: CancelData): CancelablePromise<CancelResponse> {
    return __request(OpenAPI, {
      method: "PUT",
      url: "/api/v2/add_on_subscriptions/{id}/cancel",
      path: {
        id: data.id,
      },
    });
  }
}

export class SubscriptionsService {
  /**
   * Reactivate a subscription
   * @param data The data for the request.
   * @param data.id
   * @returns unknown Subscription reactivated
   * @throws ApiError
   */
  public static reactivate(
    data: ReactivateData
  ): CancelablePromise<ReactivateResponse> {
    return __request(OpenAPI, {
      method: "PUT",
      url: "/api/v2/subscriptions/{id}/reactivate",
      path: {
        id: data.id,
      },
    });
  }

  /**
   * Preview a subscription change
   * @param data The data for the request.
   * @param data.id
   * @param data.changeProductId The product id of the plan to preview
   * @returns unknown Preview response
   * @throws ApiError
   */
  public static preview(data: PreviewData): CancelablePromise<PreviewResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/v2/subscriptions/{id}/preview",
      path: {
        id: data.id,
      },
      query: {
        change_product_id: data.changeProductId,
      },
    });
  }

  /**
   * Update a subscription
   * @param data The data for the request.
   * @param data.id Subscription ID
   * @param data.requestBody Subscription attributes
   * @returns unknown Subscription updated
   * @throws ApiError
   */
  public static update(data: UpdateData): CancelablePromise<UpdateResponse> {
    return __request(OpenAPI, {
      method: "PUT",
      url: "/api/v2/subscriptions/{id}",
      path: {
        id: data.id,
      },
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * Upgrade a subscription during intro pricing experiment (prcng-338_v1) or collapsed painted door experiment (prcng-107_v1)
   * @returns unknown Subscription upgraded
   * @throws ApiError
   */
  public static pricingUpgrade(): CancelablePromise<PricingUpgradeResponse> {
    return __request(OpenAPI, {
      method: "PUT",
      url: "/api/v2/subscriptions/pricing-upgrade",
    });
  }
}

export class WatchBundlesService {
  /**
   * GET watch bundle
   * @param data The data for the request.
   * @param data.watchBundleUuid
   * @returns WatchBundle OK
   * @throws ApiError
   */
  public static getWatchBundle(
    data: GetWatchBundleData
  ): CancelablePromise<GetWatchBundleResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/v3/watch-bundles/{watch_bundle_uuid}",
      path: {
        watch_bundle_uuid: data.watchBundleUuid,
      },
      errors: {
        401: `The authentication credentials required to access this resource are missing or invalid.
`,
        404: `The resource could not be found. Either the resource does not exist or the user does not have authorization to access the resource.
`,
      },
    });
  }

  /**
   * GET watch bundle extras
   * @param data The data for the request.
   * @param data.watchBundleUuid
   * @returns WatchBundleExtras OK
   * @throws ApiError
   */
  public static getWatchBundleExtras(
    data: GetWatchBundleExtrasData
  ): CancelablePromise<GetWatchBundleExtrasResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/v3/watch-bundles/{watch_bundle_uuid}/extras",
      path: {
        watch_bundle_uuid: data.watchBundleUuid,
      },
      errors: {
        401: `The authentication credentials required to access this resource are missing or invalid.
`,
        404: `The resource could not be found. Either the resource does not exist or the user does not have authorization to access the resource.
`,
      },
    });
  }

  /**
   * GET watch bundle interactions
   * @param data The data for the request.
   * @param data.watchBundleUuid
   * @returns WatchBundleInteractions OK
   * @throws ApiError
   */
  public static getWatchBundleInteractions(
    data: GetWatchBundleInteractionsData
  ): CancelablePromise<GetWatchBundleInteractionsResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/v3/watch-bundles/{watch_bundle_uuid}/interactions",
      path: {
        watch_bundle_uuid: data.watchBundleUuid,
      },
      errors: {
        401: `The authentication credentials required to access this resource are missing or invalid.
`,
        404: `The resource could not be found. Either the resource does not exist or the user does not have authorization to access the resource.
`,
      },
    });
  }

  /**
   * PATCH bookmark
   * @param data The data for the request.
   * @param data.uuid The unique identifier of a resource to bookmark.
   * @returns V3Bookmark OK
   * @throws ApiError
   */
  public static addBookmark(
    data: AddBookmarkData
  ): CancelablePromise<AddBookmarkResponse> {
    return __request(OpenAPI, {
      method: "PATCH",
      url: "/api/v3/bookmarks/{uuid}",
      path: {
        uuid: data.uuid,
      },
      errors: {
        400: "The request body was invalid.",
        401: `The authentication credentials required to access this resource are missing or invalid.
`,
        404: `The resource could not be found. Either the resource does not exist or the user does not have authorization to access the resource.
`,
      },
    });
  }

  /**
   * DELETE bookmark
   * @param data The data for the request.
   * @param data.uuid The unique identifier of a resource to bookmark.
   * @returns void No Content. The bookmark was removed from the resource.
   * @throws ApiError
   */
  public static removeBookmark(
    data: RemoveBookmarkData
  ): CancelablePromise<RemoveBookmarkResponse> {
    return __request(OpenAPI, {
      method: "DELETE",
      url: "/api/v3/bookmarks/{uuid}",
      path: {
        uuid: data.uuid,
      },
      errors: {
        401: `The authentication credentials required to access this resource are missing or invalid.
`,
        404: `The resource could not be found. Either the resource does not exist or the user does not have authorization to access the resource.
`,
      },
    });
  }

  /**
   * PATCH note
   * @param data The data for the request.
   * @param data.requestBody
   * @param data.contentUuid
   * @returns V3Note OK
   * @throws ApiError
   */
  public static patchNote(
    data: PatchNoteData
  ): CancelablePromise<PatchNoteResponse> {
    return __request(OpenAPI, {
      method: "PATCH",
      url: "/api/v3/notes/{content_uuid}",
      path: {
        content_uuid: data.contentUuid,
      },
      body: data.requestBody,
      mediaType: "application/json",
      errors: {
        400: "The request body was invalid.",
        401: `The authentication credentials required to access this resource are missing or invalid.
`,
        404: `The resource could not be found. Either the resource does not exist or the user does not have authorization to access the resource.
`,
      },
    });
  }

  /**
   * DELETE note
   * @param data The data for the request.
   * @param data.contentUuid
   * @returns void No Content. The note was destroyed.
   * @throws ApiError
   */
  public static destroyNote(
    data: DestroyNoteData
  ): CancelablePromise<DestroyNoteResponse> {
    return __request(OpenAPI, {
      method: "DELETE",
      url: "/api/v3/notes/{content_uuid}",
      path: {
        content_uuid: data.contentUuid,
      },
      errors: {
        401: `The authentication credentials required to access this resource are missing or invalid.
`,
        404: `The resource could not be found. Either the resource does not exist or the user does not have authorization to access the resource.
`,
      },
    });
  }
}

export class WatchBundlesContentsService {
  /**
   * GET watch bundle content interactions
   * @param data The data for the request.
   * @param data.contentUuid Content uuid
   * @returns WatchBundleContentInteractions OK
   * @throws ApiError
   */
  public static getWatchBundleContentInteractions(
    data: GetWatchBundleContentInteractionsData
  ): CancelablePromise<GetWatchBundleContentInteractionsResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/v3/watch-bundles-contents/{content_uuid}/interactions",
      path: {
        content_uuid: data.contentUuid,
      },
      errors: {
        401: `The authentication credentials required to access this resource are missing or invalid.
`,
        404: `The resource could not be found. Either the resource does not exist or the user does not have authorization to access the resource.
`,
      },
    });
  }
}

export class PlaybackService {
  /**
   * PATCH playback
   * @param data The data for the request.
   * @param data.requestBody
   * @param data.contentUuid
   * @returns Playhead OK
   * @throws ApiError
   */
  public static patchPlayback(
    data: PatchPlaybackData
  ): CancelablePromise<PatchPlaybackResponse> {
    return __request(OpenAPI, {
      method: "PATCH",
      url: "/api/v3/playback/{content_uuid}",
      path: {
        content_uuid: data.contentUuid,
      },
      body: data.requestBody,
      mediaType: "application/json",
      errors: {
        400: "The request body was invalid.",
        401: `The authentication credentials required to access this resource are missing or invalid.
`,
        404: `The resource could not be found. Either the resource does not exist or the user does not have authorization to access the resource.
`,
      },
    });
  }

  /**
   * get token
   * @returns PlaybackTokenResponse OK
   * @throws ApiError
   */
  public static getPlaybackToken(): CancelablePromise<GetPlaybackTokenResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/v3/playback/token",
      errors: {
        400: "The request body was invalid.",
        401: `The authentication credentials required to access this resource are missing or invalid.
`,
        404: `The resource could not be found. Either the resource does not exist or the user does not have authorization to access the resource.
`,
      },
    });
  }
}

export class SurveysService {
  /**
   * Update the survey response for the given content.
   * This endpoint is used to update the survey response for the given content.
   * The survey response is updated by providing the question slug and the response for the question.
   * The question slug is the slug of the question being updated.
   * The response for the question should be provided in the attribute of the same name as the step type of the question.
   *
   * @param data The data for the request.
   * @param data.requestBody
   * @param data.contentUuid
   * @returns void Survey feedback was accepted. The watch bundle interactions will be updated to indicate
   * the survey should not be taken again.
   *
   * @throws ApiError
   */
  public static updateSurveyResponse(
    data: UpdateSurveyResponseData
  ): CancelablePromise<UpdateSurveyResponseResponse> {
    return __request(OpenAPI, {
      method: "PATCH",
      url: "/api/v3/surveys/{content_uuid}",
      path: {
        content_uuid: data.contentUuid,
      },
      body: data.requestBody,
      mediaType: "application/json",
      errors: {
        400: "The request body was invalid.",
        401: `The authentication credentials required to access this resource are missing or invalid.
`,
        404: `The resource could not be found. Either the resource does not exist or the user does not have authorization to access the resource.
`,
      },
    });
  }
}

export class SharingService {
  /**
   * GET sharing
   * @param data The data for the request.
   * @param data.uuid
   * @returns Sharing OK
   * @throws ApiError
   */
  public static showSharing(
    data: ShowSharingData
  ): CancelablePromise<ShowSharingResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/v3/sharing/{uuid}",
      path: {
        uuid: data.uuid,
      },
      errors: {
        401: `The authentication credentials required to access this resource are missing or invalid.
`,
        404: `The resource could not be found. Either the resource does not exist or the user does not have authorization to access the resource.
`,
      },
    });
  }
}

export class SessionActivitiesService {
  /**
   * GET session activity interactions
   * @param data The data for the request.
   * @param data.uuid Activity uuid
   * @returns SessionActivityInteractions Session activity response
   * @throws ApiError
   */
  public static getSessionActivityInteractions(
    data: GetSessionActivityInteractionsData
  ): CancelablePromise<GetSessionActivityInteractionsResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/v3/session-activities/{uuid}/interactions",
      path: {
        uuid: data.uuid,
      },
      errors: {
        401: `The authentication credentials required to access this resource are missing or invalid.
`,
        404: `The resource could not be found. Either the resource does not exist or the user does not have authorization to access the resource.
`,
      },
    });
  }
}

export class EnterpriseService {
  /**
   * GET assignees
   * @returns Assignees OK
   * @throws ApiError
   */
  public static getAssignees(): CancelablePromise<GetAssigneesResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/v3/enterprise/assignees",
      errors: {
        400: "The request body was invalid.",
        401: `The authentication credentials required to access this resource are missing or invalid.
`,
      },
    });
  }

  /**
   * Get progress for a single content
   * @param data The data for the request.
   * @param data.uuid The unique identifier of an assignable content.
   * @param data.teamId The team identifier in which the progress content was assigned.
   * @param data.sharedBy Filters progress based on who shared
   * @param data.filters
   * @returns ContentProgress OK
   * @throws ApiError
   */
  public static getContentProgress(
    data: GetContentProgressData
  ): CancelablePromise<GetContentProgressResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/v3/enterprise/progress/{uuid}",
      path: {
        uuid: data.uuid,
      },
      query: {
        team_id: data.teamId,
        shared_by: data.sharedBy,
        filters: data.filters,
      },
      errors: {
        401: `The authentication credentials required to access this resource are missing or invalid.
`,
      },
    });
  }

  /**
   * Get all assignments
   * @returns AssignedContents OK
   * @throws ApiError
   */
  public static getAssignments(): CancelablePromise<GetAssignmentsResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/v3/enterprise/assignments",
      errors: {
        401: `The authentication credentials required to access this resource are missing or invalid.
`,
      },
    });
  }

  /**
   * Create assignments for multiple assignees
   * @param data The data for the request.
   * @param data.requestBody
   * @param data.xRequestId
   * @returns unknown OK
   * @throws ApiError
   */
  public static createAssignments(
    data: CreateAssignmentsData
  ): CancelablePromise<CreateAssignmentsResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/v3/enterprise/assignments",
      headers: {
        "X-Request-Id": data.xRequestId,
      },
      body: data.requestBody,
      mediaType: "application/json",
      errors: {
        401: `The authentication credentials required to access this resource are missing or invalid.
`,
      },
    });
  }

  /**
   * Delete assignment for a single user
   * @param data The data for the request.
   * @param data.contentUuid
   * @param data.requestBody
   * @returns void OK
   * @throws ApiError
   */
  public static destroyAssignment(
    data: DestroyAssignmentData
  ): CancelablePromise<DestroyAssignmentResponse> {
    return __request(OpenAPI, {
      method: "DELETE",
      url: "/api/v3/enterprise/assignments/{content_uuid}",
      path: {
        content_uuid: data.contentUuid,
      },
      body: data.requestBody,
      mediaType: "application/json",
      errors: {
        401: `The authentication credentials required to access this resource are missing or invalid.
`,
      },
    });
  }

  /**
   * List of assignable content
   * @returns AssignableContentResult OK
   * @throws ApiError
   */
  public static getAssignableContent(): CancelablePromise<GetAssignableContentResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/v3/enterprise/assignable-content",
    });
  }

  /**
   * GET navigation permitted to the current user
   * @returns NavigationContents OK
   * @throws ApiError
   */
  public static getNavigation(): CancelablePromise<GetNavigationResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/v3/enterprise/admin/navigation",
      errors: {
        401: `The authentication credentials required to access this resource are missing or invalid.
`,
      },
    });
  }

  /**
   * GET Organization info from current user
   * @param data The data for the request.
   * @param data.id
   * @returns V3Organization OK
   * @throws ApiError
   */
  public static getOrganizationInfo(
    data: GetOrganizationInfoData
  ): CancelablePromise<GetOrganizationInfoResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/v3/enterprise/admin/organizations/{id}",
      path: {
        id: data.id,
      },
      errors: {
        401: `The authentication credentials required to access this resource are missing or invalid.
`,
        404: `The resource is not found
`,
      },
    });
  }

  /**
   * Download a CSV template used to import bulk users
   * @returns string OK
   * @throws ApiError
   */
  public static getTemplateBulkImport(): CancelablePromise<GetTemplateBulkImportResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/v3/enterprise/admin/template-bulk-import",
      errors: {
        401: `The authentication credentials required to access this resource are missing or invalid.
`,
      },
    });
  }

  /**
   * GET skills
   * @returns EnterprisePlaylistSkill OK
   * @throws ApiError
   */
  public static getEnterpriseSkills(): CancelablePromise<GetEnterpriseSkillsResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/v3/skills",
      errors: {
        401: `The authentication credentials required to access this resource are missing or invalid.
`,
      },
    });
  }

  /**
   * GET playlists
   * @param data The data for the request.
   * @param data.organizationId The unique identifier of an organization.
   * @returns V3Playlists OK
   * @throws ApiError
   */
  public static v3GetPlaylists(
    data: V3GetPlaylistsData
  ): CancelablePromise<V3GetPlaylistsResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/v3/enterprise/playlists",
      query: {
        organization_id: data.organizationId,
      },
      errors: {
        401: `The authentication credentials required to access this resource are missing or invalid.
`,
        404: `The resource is not found
`,
      },
    });
  }

  /**
   * Create a new playlist
   * Create playlist
   * @param data The data for the request.
   * @param data.requestBody
   * @returns CreatedPlaylist Created
   * @throws ApiError
   */
  public static createPlaylist(
    data: CreatePlaylistData
  ): CancelablePromise<CreatePlaylistResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/v3/enterprise/playlists",
      body: data.requestBody,
      mediaType: "application/json",
      errors: {
        401: `The authentication credentials required to access this resource are missing or invalid.
`,
        409: `This playlist title already exists. Try a different one.
`,
      },
    });
  }

  /**
   * Gets a playlist by UUID
   * @param data The data for the request.
   * @param data.uuid The unique identifier of a playlist.
   * @returns V3Playlist OK
   * @throws ApiError
   */
  public static v3GetPlaylist(
    data: V3GetPlaylistData
  ): CancelablePromise<V3GetPlaylistResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/v3/enterprise/playlists/{uuid}",
      path: {
        uuid: data.uuid,
      },
      errors: {
        401: `The authentication credentials required to access this resource are missing or invalid.
`,
        404: `The resource is not found
`,
      },
    });
  }

  /**
   * Update playlist
   * @param data The data for the request.
   * @param data.uuid The unique identifier of a playlist.
   * @param data.formData
   * @returns void OK
   * @throws ApiError
   */
  public static updatePlaylist(
    data: UpdatePlaylistData
  ): CancelablePromise<UpdatePlaylistResponse> {
    return __request(OpenAPI, {
      method: "PATCH",
      url: "/api/v3/enterprise/playlists/{uuid}",
      path: {
        uuid: data.uuid,
      },
      formData: data.formData,
      mediaType: "multipart/form-data",
      errors: {
        400: "The request body was invalid.",
        401: `The authentication credentials required to access this resource are missing or invalid.
`,
        404: `The resource is not found
`,
      },
    });
  }

  /**
   * Delete playlist
   * @param data The data for the request.
   * @param data.uuid The unique identifier of a playlist.
   * @returns void OK
   * @throws ApiError
   */
  public static deletePlaylist(
    data: DeletePlaylistData
  ): CancelablePromise<DeletePlaylistResponse> {
    return __request(OpenAPI, {
      method: "DELETE",
      url: "/api/v3/enterprise/playlists/{uuid}",
      path: {
        uuid: data.uuid,
      },
      errors: {
        401: `The authentication credentials required to access this resource are missing or invalid.
`,
        404: `The resource is not found
`,
      },
    });
  }

  /**
   * Publish playlist
   * @param data The data for the request.
   * @param data.uuid The unique identifier of a playlist.
   * @returns void OK
   * @throws ApiError
   */
  public static publishPlaylist(
    data: PublishPlaylistData
  ): CancelablePromise<PublishPlaylistResponse> {
    return __request(OpenAPI, {
      method: "PATCH",
      url: "/api/v3/enterprise/playlists/{uuid}/publish",
      path: {
        uuid: data.uuid,
      },
      errors: {
        401: `The authentication credentials required to access this resource are missing or invalid.
`,
        404: `The resource is not found
`,
      },
    });
  }

  /**
   * Unpublish playlist
   * @param data The data for the request.
   * @param data.uuid The unique identifier of a playlist.
   * @returns void OK
   * @throws ApiError
   */
  public static unpublishPlaylist(
    data: UnpublishPlaylistData
  ): CancelablePromise<UnpublishPlaylistResponse> {
    return __request(OpenAPI, {
      method: "PATCH",
      url: "/api/v3/enterprise/playlists/{uuid}/unpublish",
      path: {
        uuid: data.uuid,
      },
      errors: {
        401: `The authentication credentials required to access this resource are missing or invalid.
`,
        404: `The resource is not found
`,
      },
    });
  }

  /**
   * Duplicate playlist
   * @param data The data for the request.
   * @param data.uuid The unique identifier of a playlist.
   * @param data.requestBody
   * @returns CreatedPlaylist Created
   * @throws ApiError
   */
  public static duplicatePlaylist(
    data: DuplicatePlaylistData
  ): CancelablePromise<DuplicatePlaylistResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/v3/enterprise/playlists/{uuid}/duplicate",
      path: {
        uuid: data.uuid,
      },
      body: data.requestBody,
      mediaType: "application/json",
      errors: {
        401: `The authentication credentials required to access this resource are missing or invalid.
`,
        404: `The resource is not found
`,
      },
    });
  }

  /**
   * Gets lessons from a playlist by UUID
   * @param data The data for the request.
   * @param data.playlistUuid The unique identifier of a playlist.
   * @returns EnterprisePlaylistLesson OK
   * @throws ApiError
   */
  public static getLessonsFromPlaylist(
    data: GetLessonsFromPlaylistData
  ): CancelablePromise<GetLessonsFromPlaylistResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/v3/enterprise/playlists/{playlist_uuid}/lessons",
      path: {
        playlist_uuid: data.playlistUuid,
      },
      errors: {
        401: `The authentication credentials required to access this resource are missing or invalid.
`,
        404: `The resource is not found
`,
      },
    });
  }

  /**
   * Add lessons to a playlist
   * @param data The data for the request.
   * @param data.playlistUuid
   * @param data.requestBody
   * @returns unknown Created
   * @throws ApiError
   */
  public static addLessonsToPlaylist(
    data: AddLessonsToPlaylistData
  ): CancelablePromise<AddLessonsToPlaylistResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/v3/enterprise/playlists/{playlist_uuid}/lessons",
      path: {
        playlist_uuid: data.playlistUuid,
      },
      body: data.requestBody,
      mediaType: "application/json",
      errors: {
        401: `The authentication credentials required to access this resource are missing or invalid.
`,
      },
    });
  }

  /**
   * Reorder lessons in a playlist by UUID
   * @param data The data for the request.
   * @param data.playlistUuid The unique identifier of a playlist.
   * @param data.requestBody
   * @returns void OK
   * @throws ApiError
   */
  public static reorderLessonsInPlaylist(
    data: ReorderLessonsInPlaylistData
  ): CancelablePromise<ReorderLessonsInPlaylistResponse> {
    return __request(OpenAPI, {
      method: "PATCH",
      url: "/api/v3/enterprise/playlists/{playlist_uuid}/lessons/reorder",
      path: {
        playlist_uuid: data.playlistUuid,
      },
      body: data.requestBody,
      mediaType: "application/json",
      errors: {
        401: `The authentication credentials required to access this resource are missing or invalid.
`,
        404: `The resource is not found
`,
      },
    });
  }

  /**
   * Update a lesson in a playlist by UUID
   * @param data The data for the request.
   * @param data.playlistUuid The unique identifier of a playlist.
   * @param data.lessonUuid The unique identifier of a lesson.
   * @param data.requestBody
   * @returns void OK
   * @throws ApiError
   */
  public static updateLessonInPlaylist(
    data: UpdateLessonInPlaylistData
  ): CancelablePromise<UpdateLessonInPlaylistResponse> {
    return __request(OpenAPI, {
      method: "PATCH",
      url: "/api/v3/enterprise/playlists/{playlist_uuid}/lessons/{lesson_uuid}",
      path: {
        playlist_uuid: data.playlistUuid,
        lesson_uuid: data.lessonUuid,
      },
      body: data.requestBody,
      mediaType: "application/json",
      errors: {
        401: `The authentication credentials required to access this resource are missing or invalid.
`,
        404: `The resource is not found
`,
      },
    });
  }

  /**
   * Remove lesson from playlist
   * @param data The data for the request.
   * @param data.playlistUuid The unique identifier of a playlist.
   * @param data.lessonUuid The unique identifier of a lesson.
   * @returns void OK
   * @throws ApiError
   */
  public static removeLessonFromPlaylist(
    data: RemoveLessonFromPlaylistData
  ): CancelablePromise<RemoveLessonFromPlaylistResponse> {
    return __request(OpenAPI, {
      method: "DELETE",
      url: "/api/v3/enterprise/playlists/{playlist_uuid}/lessons/{lesson_uuid}",
      path: {
        playlist_uuid: data.playlistUuid,
        lesson_uuid: data.lessonUuid,
      },
      errors: {
        401: `The authentication credentials required to access this resource are missing or invalid.
`,
        404: `The resource is not found
`,
      },
    });
  }

  /**
   * Gets a program by slug
   * @param data The data for the request.
   * @param data.programSlug The unique identifier of a program.
   * @returns Program OK
   * @throws ApiError
   */
  public static getProgram(
    data: GetProgramData
  ): CancelablePromise<GetProgramResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/v3/enterprise/programs/{program_slug}",
      path: {
        program_slug: data.programSlug,
      },
      errors: {
        401: `The authentication credentials required to access this resource are missing or invalid.
`,
        404: `The resource is not found
`,
      },
    });
  }

  /**
   * Enroll current user in program
   * @param data The data for the request.
   * @param data.programSlug The unique identifier of a program.
   * @returns unknown Enrolled
   * @throws ApiError
   */
  public static enrollPrograms(
    data: EnrollProgramsData
  ): CancelablePromise<EnrollProgramsResponse> {
    return __request(OpenAPI, {
      method: "PUT",
      url: "/api/v3/enterprise/programs/{program_slug}/enroll",
      path: {
        program_slug: data.programSlug,
      },
      errors: {
        401: `The authentication credentials required to access this resource are missing or invalid.
`,
      },
    });
  }

  /**
   * Download resources in a ZIP file
   * @param data The data for the request.
   * @param data.programSlug The unique identifier of a program.
   * @param data.stage Files to be compressed that belong to the same section.
   * @returns binary A ZIP file
   * @throws ApiError
   */
  public static getProgramDownloadResources(
    data: GetProgramDownloadResourcesData
  ): CancelablePromise<GetProgramDownloadResourcesResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/v3/enterprise/programs/{program_slug}/download-resources",
      path: {
        program_slug: data.programSlug,
      },
      query: {
        stage: data.stage,
      },
      errors: {
        401: `The authentication credentials required to access this resource are missing or invalid.
`,
        404: `The resource is not found
`,
      },
    });
  }

  /**
   * Download resources in a ZIP file
   * @param data The data for the request.
   * @param data.programSlug The unique identifier of a program.
   * @param data.moduleSlug The unique identifier of a module.
   * @returns binary A ZIP file
   * @throws ApiError
   */
  public static getModuleDownloadResources(
    data: GetModuleDownloadResourcesData
  ): CancelablePromise<GetModuleDownloadResourcesResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/v3/enterprise/programs/{program_slug}/modules/{module_slug}/download-resources",
      path: {
        program_slug: data.programSlug,
        module_slug: data.moduleSlug,
      },
      errors: {
        401: `The authentication credentials required to access this resource are missing or invalid.
`,
        404: `The resource is not found
`,
      },
    });
  }

  /**
   * Generate a quote for an Enterprise products
   * Generate Quote for Enterprise Products
   * @param data The data for the request.
   * @param data.requestBody
   * @returns EnterpriseQuote Generated
   * @throws ApiError
   */
  public static getQuote(
    data: GetQuoteData
  ): CancelablePromise<GetQuoteResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/v3/enterprise/quote",
      body: data.requestBody,
      mediaType: "application/json",
      errors: {
        400: `The input to the quote service is invalid
`,
      },
    });
  }

  /**
   * Generate an addon quote for an existing Enterprise License
   * Generate Addon Quote for an existing Enterprise License
   * @param data The data for the request.
   * @param data.requestBody
   * @returns EnterpriseQuote Generated
   * @throws ApiError
   */
  public static getAddonQuote(
    data: GetAddonQuoteData
  ): CancelablePromise<GetAddonQuoteResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/v3/enterprise/addon-quote",
      body: data.requestBody,
      mediaType: "application/json",
      errors: {
        400: `The input to the quote service is invalid
`,
        401: `The authentication credentials required to access this resource are missing or invalid.
`,
      },
    });
  }

  /**
   * Process an addon order for existing Enterprise products
   * Process an Addon Order for Enterprise Products
   * @param data The data for the request.
   * @param data.requestBody
   * @returns EnterpriseAddonOrder Processed
   * @throws ApiError
   */
  public static processAddonOrder(
    data: ProcessAddonOrderData
  ): CancelablePromise<ProcessAddonOrderResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/v3/enterprise/process-addon-order",
      body: data.requestBody,
      mediaType: "application/json",
      errors: {
        400: `The input to the order service is invalid
`,
        401: `The authentication credentials required to access this resource are missing or invalid.
`,
      },
    });
  }

  /**
   * Process an order for Enterprise products
   * Process an Order for Enterprise Products
   * @param data The data for the request.
   * @param data.requestBody
   * @returns EnterpriseOrder Order Processed
   * @throws ApiError
   */
  public static processOrder(
    data: ProcessOrderData
  ): CancelablePromise<ProcessOrderResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/v3/enterprise/process-order",
      body: data.requestBody,
      mediaType: "application/json",
      errors: {
        400: `The input to the order service is invalid
`,
      },
    });
  }

  /**
   * Gets an invoice for a Self Serve order
   * Retrieve self serve invoice
   * @param data The data for the request.
   * @param data.invoiceId The unique identifier of the invoice.
   * @returns EnterpriseInvoice Invoice ready
   * @throws ApiError
   */
  public static getInvoice(
    data: GetInvoiceData
  ): CancelablePromise<GetInvoiceResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/v3/enterprise/invoice/{invoice_id}",
      path: {
        invoice_id: data.invoiceId,
      },
      errors: {
        404: `The invoice does not exist
`,
      },
    });
  }

  /**
   * GET licenses
   * @returns EnterpriseLicenses OK
   * @throws ApiError
   */
  public static getLicenses(): CancelablePromise<GetLicensesResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/v3/enterprise/licenses",
      errors: {
        401: `The authentication credentials required to access this resource are missing or invalid.
`,
      },
    });
  }

  /**
   * Revoke consent for a license
   * @returns void OK
   * @throws ApiError
   */
  public static revokeConsent(): CancelablePromise<RevokeConsentResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/v3/enterprise/licenses/revoke-consent",
      errors: {
        401: `The authentication credentials required to access this resource are missing or invalid.
`,
      },
    });
  }

  /**
   * GET metric
   * @param data The data for the request.
   * @param data.slug
   * @param data.teamId
   * @param data.filters
   * @returns EnterpriseAnalyticsMetric OK
   * @throws ApiError
   */
  public static getMetric(
    data: GetMetricData
  ): CancelablePromise<GetMetricResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/v3/enterprise/analytics/metrics/{slug}",
      path: {
        slug: data.slug,
      },
      query: {
        team_id: data.teamId,
        filters: data.filters,
      },
      errors: {
        401: `The authentication credentials required to access this resource are missing or invalid.
`,
      },
    });
  }

  /**
   * CREATE generate-csv-report-job
   * @param data The data for the request.
   * @param data.requestBody generate-csv-report-job request body
   * @returns EnterpriseAnalyticsGenerateCsvReportJobResponse OK
   * @throws ApiError
   */
  public static createGenerateCsvReportJob(
    data: CreateGenerateCsvReportJobData
  ): CancelablePromise<CreateGenerateCsvReportJobResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/v3/enterprise/analytics/generate-csv-report-jobs",
      body: data.requestBody,
      mediaType: "application/json",
      errors: {
        400: `The request format is not valid.
`,
        401: `The authentication credentials required to access this resource are missing or invalid.
`,
        403: `The request is not authorized
`,
        404: `The resource is not found
`,
      },
    });
  }

  /**
   * GET generate-csv-report-job
   * @param data The data for the request.
   * @param data.uuid
   * @returns EnterpriseAnalyticsGenerateCsvReportJobResponse OK
   * @throws ApiError
   */
  public static getGenerateCsvReportJob(
    data: GetGenerateCsvReportJobData
  ): CancelablePromise<GetGenerateCsvReportJobResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/v3/enterprise/analytics/generate-csv-report-jobs/{uuid}",
      path: {
        uuid: data.uuid,
      },
      errors: {
        401: `The authentication credentials required to access this resource are missing or invalid.
`,
        403: `The request is not authorized
`,
        404: `The resource is not found
`,
      },
    });
  }
}

export class ContentRowsV3Service {
  /**
   * Primary Content Rows index endpoint
   * @param data The data for the request.
   * @param data.filter
   * @param data.resourceUuid
   * @param data.includeItems
   * @param data.entityType Used to filter out tiles with a different entity_type
   * @returns V3ContentRows List of content rows
   * @throws ApiError
   */
  public static getContentRowsV3(
    data: GetContentRowsV3Data
  ): CancelablePromise<GetContentRowsV3Response> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/jsonapi/v3/content-rows",
      query: {
        filter: data.filter,
        resource_uuid: data.resourceUuid,
        include_items: data.includeItems,
        entity_type: data.entityType,
      },
    });
  }
}

export class UniqueIdentifiersService {
  /**
   * GET uuid resource with a given slug and type
   * @param data The data for the request.
   * @param data.resourceTypePlural Type of the resource in plural.
   * @param data.slug Slug of the resource.
   * @returns UniqueIdentifiersResponse OK
   * @throws ApiError
   */
  public static getResourceUniqueIdentifier(
    data: GetResourceUniqueIdentifierData
  ): CancelablePromise<GetResourceUniqueIdentifierResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/v3/unique-identifiers/{resource_type_plural}/{slug}",
      path: {
        resource_type_plural: data.resourceTypePlural,
        slug: data.slug,
      },
      errors: {
        404: `The resource could not be found. Either the resource does not exist or the user does not have authorization to access the resource.
`,
      },
    });
  }
}

export class MyListService {
  /**
   * Get all content uuids from my list
   * @returns MyListItem OK
   * @throws ApiError
   */
  public static getMyList(): CancelablePromise<GetMyListResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/v3/my-list",
      errors: {
        401: `The authentication credentials required to access this resource are missing or invalid.
`,
        404: `The resource could not be found. Either the resource does not exist or the user does not have authorization to access the resource.
`,
      },
    });
  }

  /**
   * Add content to my list
   * @param data The data for the request.
   * @param data.contentUuid
   * @returns unknown OK
   * @throws ApiError
   */
  public static addToMyList(
    data: AddToMyListData
  ): CancelablePromise<AddToMyListResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/v3/my-list/{content_uuid}",
      path: {
        content_uuid: data.contentUuid,
      },
      errors: {
        400: "The request body was invalid.",
        401: `The authentication credentials required to access this resource are missing or invalid.
`,
        404: `The resource could not be found. Either the resource does not exist or the user does not have authorization to access the resource.
`,
      },
    });
  }

  /**
   * DELETE my list item
   * @param data The data for the request.
   * @param data.contentUuid
   * @returns void No Content. The content was removed from My List.
   * @throws ApiError
   */
  public static removeFromMyList(
    data: RemoveFromMyListData
  ): CancelablePromise<RemoveFromMyListResponse> {
    return __request(OpenAPI, {
      method: "DELETE",
      url: "/api/v3/my-list/{content_uuid}",
      path: {
        content_uuid: data.contentUuid,
      },
      errors: {
        401: `The authentication credentials required to access this resource are missing or invalid.
`,
        404: `The resource could not be found. Either the resource does not exist or the user does not have authorization to access the resource.
`,
      },
    });
  }
}

export class HomepageLayoutService {
  /**
   * GET homepage layout
   * @returns HomepageLayout Get list of navigation tabs
   * @throws ApiError
   */
  public static getHomepageLayout(): CancelablePromise<GetHomepageLayoutResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/v3/homepage-layout",
    });
  }
}

export class SemanticSearchService {
  /**
   * GET semantic search
   * @param data The data for the request.
   * @param data.q The question asked by the user
   * @returns SemanticSearchResponse OK
   * @throws ApiError
   */
  public static getSemanticSearch(
    data: GetSemanticSearchData
  ): CancelablePromise<GetSemanticSearchResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/v3/semantic-search",
      query: {
        q: data.q,
      },
      errors: {
        401: `The authentication credentials required to access this resource are missing or invalid.
`,
        404: `The resource could not be found. Either the resource does not exist or the user does not have authorization to access the resource.
`,
      },
    });
  }
}

export class AppDataService {
  /**
   * Get data related to the app
   * @returns AppData OK
   * @throws ApiError
   */
  public static getAppData(): CancelablePromise<GetAppDataResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/v3/app-data",
    });
  }
}

export class LearningPreferencesService {
  /**
   * PATCH user career goals, skills, and sub-skills
   * @param data The data for the request.
   * @param data.requestBody
   * @returns void OK
   * @throws ApiError
   */
  public static updateLearningPreferences(
    data: UpdateLearningPreferencesData
  ): CancelablePromise<UpdateLearningPreferencesResponse> {
    return __request(OpenAPI, {
      method: "PATCH",
      url: "/api/v3/learning-preferences",
      body: data.requestBody,
      mediaType: "application/json",
      errors: {
        400: "The request body was invalid.",
        401: `The authentication credentials required to access this resource are missing or invalid.
`,
        404: `The resource could not be found. Either the resource does not exist or the user does not have authorization to access the resource.
`,
      },
    });
  }

  /**
   * GET the career goal page to be displayed
   * @returns CareerGoalPage OK
   * @throws ApiError
   */
  public static getCareerGoal(): CancelablePromise<GetCareerGoalResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/v3/learning-preferences/career-goal",
      errors: {
        400: "The request body was invalid.",
        401: `The authentication credentials required to access this resource are missing or invalid.
`,
        404: `The resource could not be found. Either the resource does not exist or the user does not have authorization to access the resource.
`,
      },
    });
  }

  /**
   * GET the skills to be displayed
   * @param data The data for the request.
   * @param data.careerGoal The career goal selected
   * @returns SkillsPage OK
   * @throws ApiError
   */
  public static v3GetSkills(
    data: V3GetSkillsData
  ): CancelablePromise<V3GetSkillsResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/v3/learning-preferences/skills",
      query: {
        career_goal: data.careerGoal,
      },
      errors: {
        400: "The request body was invalid.",
        401: `The authentication credentials required to access this resource are missing or invalid.
`,
        404: `The resource could not be found. Either the resource does not exist or the user does not have authorization to access the resource.
`,
      },
    });
  }

  /**
   * GET the subskills to be displayed
   * @param data The data for the request.
   * @param data.skills The skills selected
   * @returns SubskillsPage OK
   * @throws ApiError
   */
  public static getSubskills(
    data: GetSubskillsData
  ): CancelablePromise<GetSubskillsResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/v3/learning-preferences/subskills",
      query: {
        skills: data.skills,
      },
      errors: {
        400: "The request body was invalid.",
        401: `The authentication credentials required to access this resource are missing or invalid.
`,
        404: `The resource could not be found. Either the resource does not exist or the user does not have authorization to access the resource.
`,
      },
    });
  }
}

export class TabContentService {
  /**
   * Get content that will be presented on UI tab
   * @param data The data for the request.
   * @param data.xPlatform
   * @param data.navigation
   * @param data.tab
   * @returns TabContent Get content that will be presented on UI tab
   * @throws ApiError
   */
  public static getTabContent(
    data: GetTabContentData = {}
  ): CancelablePromise<GetTabContentResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/v3/tab-content",
      headers: {
        "X-Platform": data.xPlatform,
      },
      query: {
        navigation: data.navigation,
        tab: data.tab,
      },
    });
  }
}

export class CollectionsService {
  /**
   * Get collection rows used to display a selection of collections.
   * @returns CollectionRows OK
   * @throws ApiError
   */
  public static getCollectionRows(): CancelablePromise<GetCollectionRowsResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/v3/collection-rows",
      errors: {
        401: `The authentication credentials required to access this resource are missing or invalid.
`,
      },
    });
  }

  /**
   * GET all the content for one specific collection.
   * @param data The data for the request.
   * @param data.collectionUuid
   * @returns Collection OK
   * @throws ApiError
   */
  public static getCollection(
    data: GetCollectionData
  ): CancelablePromise<GetCollectionResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/v3/collections/{collection_uuid}",
      path: {
        collection_uuid: data.collectionUuid,
      },
      errors: {
        401: `The authentication credentials required to access this resource are missing or invalid.
`,
      },
    });
  }

  /**
   * Update card progress, which marks the card as viewed.
   * @param data The data for the request.
   * @param data.cardUuid
   * @returns void Card was marked as viewed successfully
   * @throws ApiError
   */
  public static updateCardProgress(
    data: UpdateCardProgressData
  ): CancelablePromise<UpdateCardProgressResponse> {
    return __request(OpenAPI, {
      method: "PATCH",
      url: "/api/v3/card-progress/{card_uuid}",
      path: {
        card_uuid: data.cardUuid,
      },
      errors: {
        401: `The authentication credentials required to access this resource are missing or invalid.
`,
      },
    });
  }

  /**
   * GET all the interactions for a specific collection, such as user progress and resume part information.
   * @param data The data for the request.
   * @param data.collectionUuid
   * @returns CollectionInteractions OK
   * @throws ApiError
   */
  public static getCollectionInteractions(
    data: GetCollectionInteractionsData
  ): CancelablePromise<GetCollectionInteractionsResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/v3/collections/{collection_uuid}/interactions",
      path: {
        collection_uuid: data.collectionUuid,
      },
      errors: {
        401: `The authentication credentials required to access this resource are missing or invalid.
`,
      },
    });
  }
}

export class OnboardingService {
  /**
   * Create a new onboarding
   * Create onboarding
   * @returns Onboarding New onboarding
   * @throws ApiError
   */
  public static createOnboarding(): CancelablePromise<CreateOnboardingResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/v3/onboarding",
      errors: {
        400: "The request body was invalid.",
        401: `The authentication credentials required to access this resource are missing or invalid.
`,
        404: `The resource could not be found. Either the resource does not exist or the user does not have authorization to access the resource.
`,
      },
    });
  }

  /**
   * Update existing onboarding
   * Update onboarding
   * @param data The data for the request.
   * @param data.id Onboarding Id
   * @returns void OK
   * @throws ApiError
   */
  public static updateOnboarding(
    data: UpdateOnboardingData
  ): CancelablePromise<UpdateOnboardingResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/v3/onboarding/{id}/complete",
      path: {
        id: data.id,
      },
      errors: {
        400: "The request body was invalid.",
        401: `The authentication credentials required to access this resource are missing or invalid.
`,
        404: `The resource could not be found. Either the resource does not exist or the user does not have authorization to access the resource.
`,
      },
    });
  }
}

export class SessionPreferencesService {
  /**
   * Update session preferences
   * @param data The data for the request.
   * @param data.requestBody
   * @param data.uuid Session uuid
   * @returns void No Content
   * @throws ApiError
   */
  public static updateSessionPreferences(
    data: UpdateSessionPreferencesData
  ): CancelablePromise<UpdateSessionPreferencesResponse> {
    return __request(OpenAPI, {
      method: "PATCH",
      url: "/api/v3/session-preferences/{uuid}",
      path: {
        uuid: data.uuid,
      },
      body: data.requestBody,
      mediaType: "application/json",
      errors: {
        401: `The authentication credentials required to access this resource are missing or invalid.
`,
      },
    });
  }
}

export class IterableService {
  /**
   * GET Iterable JWT
   * @returns IterableToken Get a valid JWT
   * @throws ApiError
   */
  public static getIterableToken(): CancelablePromise<GetIterableTokenResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/v3/iterable-token",
    });
  }
}

export class PartnershipService {
  /**
   * GET eligible information
   * @param data The data for the request.
   * @param data.uuid The unique identifier of a resource to redeem.
   * @returns RevolutEligibleGift OK
   * @throws ApiError
   */
  public static getEligibleInfo(
    data: GetEligibleInfoData
  ): CancelablePromise<GetEligibleInfoResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/v3/partnerships/revolut/eligible/{uuid}",
      path: {
        uuid: data.uuid,
      },
      errors: {
        401: `The authentication credentials required to access this resource are missing or invalid.
`,
        404: `The resource is not found
`,
      },
    });
  }

  /**
   * Activate a subscription
   * Activate a  gift subscription from Revolut
   * @param data The data for the request.
   * @param data.uuid The unique identifier of a resource to redeem.
   * @returns unknown Activation successfully
   *
   * @throws ApiError
   */
  public static activateRevolutGift(
    data: ActivateRevolutGiftData
  ): CancelablePromise<ActivateRevolutGiftResponse> {
    return __request(OpenAPI, {
      method: "PUT",
      url: "/api/v3/partnerships/revolut/activate/{uuid}",
      path: {
        uuid: data.uuid,
      },
      errors: {
        401: `The authentication credentials required to access this resource are missing or invalid.
`,
        409: `The activation fails due to un-eligible status.
`,
      },
    });
  }
}

export class CertificateProgramsService {
  /**
   * Certificate Program Catalog
   * Get Certificate Program catalog for public marketing homepage
   * @returns CertificateProgramCatalog OK
   * @throws ApiError
   */
  public static getCertificateProgramCatalog(): CancelablePromise<GetCertificateProgramCatalogResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/v3/certificate-programs/catalog",
      errors: {
        404: `The resource could not be found.
`,
      },
    });
  }

  /**
   * Certificate Tiles
   * Get Certificate Hub tiles
   * @returns CertificateHubTiles OK
   * @throws ApiError
   */
  public static getCertificateHubTiles(): CancelablePromise<GetCertificateHubTilesResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/v3/certificate-programs/hub/tiles",
      errors: {
        401: `The authentication credentials required to access this resource are missing or invalid.
`,
        404: `The resource could not be found. Either the resource does not exist or the user does not have authorization to access the resource.
`,
      },
    });
  }

  /**
   * Get Certificate Program interactions
   * @param data The data for the request.
   * @param data.certificateProgramUuid The unique identifier of a certificate program
   * @returns CertificateProgramInteractions OK
   * @throws ApiError
   */
  public static getCertificateProgramInteractions(
    data: GetCertificateProgramInteractionsData
  ): CancelablePromise<GetCertificateProgramInteractionsResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/v3/certificate-programs/{certificate_program_uuid}/interactions",
      path: {
        certificate_program_uuid: data.certificateProgramUuid,
      },
      errors: {
        401: `The authentication credentials required to access this resource are missing or invalid.
`,
        404: `The resource could not be found. Either the resource does not exist or the user does not have authorization to access the resource.
`,
      },
    });
  }

  /**
   * Get Certificate Program details. This endpoint provides marketing content for the certificate program,
   * partner information, curriculum outline, instructors, and other pre-paywall information.
   *
   * @param data The data for the request.
   * @param data.certificateProgramUuid The unique identifier of a certificate program
   * @returns CertificateProgram OK
   * @throws ApiError
   */
  public static getCertificateProgram(
    data: GetCertificateProgramData
  ): CancelablePromise<GetCertificateProgramResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/v3/certificate-programs/{certificate_program_uuid}",
      path: {
        certificate_program_uuid: data.certificateProgramUuid,
      },
      errors: {
        401: `The authentication credentials required to access this resource are missing or invalid.
`,
        404: `The resource could not be found. Either the resource does not exist or the user does not have authorization to access the resource.
`,
      },
    });
  }

  /**
   * Get curriculum belonging to a certificate program
   * @param data The data for the request.
   * @param data.certificateProgramUuid The unique identifier of a certificate program
   * @returns Curriculum OK
   * @throws ApiError
   */
  public static getCurriculum(
    data: GetCurriculumData
  ): CancelablePromise<GetCurriculumResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/v3/certificate-programs/{certificate_program_uuid}/curriculum",
      path: {
        certificate_program_uuid: data.certificateProgramUuid,
      },
      errors: {
        401: `The authentication credentials required to access this resource are missing or invalid.
`,
        404: `The resource could not be found. Either the resource does not exist or the user does not have authorization to access the resource.
`,
      },
    });
  }

  /**
   * Post curriculum interactions
   * @param data The data for the request.
   * @param data.certificateProgramUuid The unique identifier of a certificate program
   * @returns CurriculumInteractions OK
   * @throws ApiError
   */
  public static postCurriculumInteractions(
    data: PostCurriculumInteractionsData
  ): CancelablePromise<PostCurriculumInteractionsResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/v3/certificate-programs/{certificate_program_uuid}/curriculum/interactions",
      path: {
        certificate_program_uuid: data.certificateProgramUuid,
      },
      errors: {
        401: `The authentication credentials required to access this resource are missing or invalid.
`,
        404: `The resource could not be found. Either the resource does not exist or the user does not have authorization to access the resource.
`,
      },
    });
  }

  /**
   * Get Curriculum lesson
   * @param data The data for the request.
   * @param data.certificateProgramUuid The unique identifier of a certificate program
   * @param data.lessonUuid The unique identifier of a lesson.
   * @returns CurriculumLesson OK
   * @throws ApiError
   */
  public static getCurriculumLesson(
    data: GetCurriculumLessonData
  ): CancelablePromise<GetCurriculumLessonResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/v3/certificate-programs/{certificate_program_uuid}/lessons/{lesson_uuid}",
      path: {
        certificate_program_uuid: data.certificateProgramUuid,
        lesson_uuid: data.lessonUuid,
      },
      errors: {
        401: `The authentication credentials required to access this resource are missing or invalid.
`,
        403: `The user does not have permission to access the resource.
`,
        404: `The resource could not be found. Either the resource does not exist or the user does not have authorization to access the resource.
`,
      },
    });
  }

  /**
   * Get Curriculum lesson interactions
   * @param data The data for the request.
   * @param data.certificateProgramUuid The unique identifier of a certificate program
   * @param data.lessonUuid The unique identifier of a lesson.
   * @returns CurriculumLessonInteractions OK
   * @throws ApiError
   */
  public static getCurriculumLessonInteractions(
    data: GetCurriculumLessonInteractionsData
  ): CancelablePromise<GetCurriculumLessonInteractionsResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/v3/certificate-programs/{certificate_program_uuid}/lessons/{lesson_uuid}/interactions",
      path: {
        certificate_program_uuid: data.certificateProgramUuid,
        lesson_uuid: data.lessonUuid,
      },
      errors: {
        401: `The authentication credentials required to access this resource are missing or invalid.
`,
        403: `The user does not have permission to access the resource.
`,
        404: `The resource could not be found. Either the resource does not exist or the user does not have authorization to access the resource.
`,
      },
    });
  }

  /**
   * Post Curriculum lesson interactions
   * @param data The data for the request.
   * @param data.certificateProgramUuid The unique identifier of a certificate program
   * @param data.lessonUuid The unique identifier of a lesson.
   * @returns CurriculumLessonInteractions OK
   * @throws ApiError
   */
  public static postCurriculumLessonInteractions(
    data: PostCurriculumLessonInteractionsData
  ): CancelablePromise<PostCurriculumLessonInteractionsResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/v3/certificate-programs/{certificate_program_uuid}/lessons/{lesson_uuid}/interactions",
      path: {
        certificate_program_uuid: data.certificateProgramUuid,
        lesson_uuid: data.lessonUuid,
      },
      errors: {
        401: `The authentication credentials required to access this resource are missing or invalid.
`,
        403: `The user does not have permission to access the resource.
`,
        404: `The resource could not be found. Either the resource does not exist or the user does not have authorization to access the resource.
`,
      },
    });
  }

  /**
   * Get Curriculum lesson download resources
   * @param data The data for the request.
   * @param data.certificateProgramUuid The unique identifier of a certificate program
   * @param data.lessonUuid The unique identifier of a lesson.
   * @returns binary OK
   * @throws ApiError
   */
  public static getCurriculumLessonDownloadResources(
    data: GetCurriculumLessonDownloadResourcesData
  ): CancelablePromise<GetCurriculumLessonDownloadResourcesResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/v3/certificate-programs/{certificate_program_uuid}/lessons/{lesson_uuid}/download",
      path: {
        certificate_program_uuid: data.certificateProgramUuid,
        lesson_uuid: data.lessonUuid,
      },
      errors: {
        401: `The authentication credentials required to access this resource are missing or invalid.
`,
        404: `The resource could not be found. Either the resource does not exist or the user does not have authorization to access the resource.
`,
      },
    });
  }

  /**
   * Download Curriculum capstone summary PDF
   * @param data The data for the request.
   * @param data.certificateProgramUuid The unique identifier of a certificate program
   * @param data.activityUuid The unique identifier of the capstone summary activity.
   * @returns binary OK
   * @throws ApiError
   */
  public static downloadCurriculumCapstoneSummary(
    data: DownloadCurriculumCapstoneSummaryData
  ): CancelablePromise<DownloadCurriculumCapstoneSummaryResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/v3/certificate-programs/{certificate_program_uuid}/activities/{activity_uuid}/capstone-summary/download",
      path: {
        certificate_program_uuid: data.certificateProgramUuid,
        activity_uuid: data.activityUuid,
      },
      errors: {
        401: `The authentication credentials required to access this resource are missing or invalid.
`,
        404: `The resource could not be found. Either the resource does not exist or the user does not have authorization to access the resource.
`,
      },
    });
  }

  /**
   * Submit Curriculum quiz activity
   * @param data The data for the request.
   * @param data.certificateProgramUuid The unique identifier of a certificate program
   * @param data.activityUuid The unique identifier of the activity.
   * @param data.requestBody
   * @returns CurriculumQuizActivityInteractions OK
   * @throws ApiError
   */
  public static submitCurriculumQuizActivity(
    data: SubmitCurriculumQuizActivityData
  ): CancelablePromise<SubmitCurriculumQuizActivityResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/v3/certificate-programs/{certificate_program_uuid}/activities/{activity_uuid}/quiz/submit",
      path: {
        certificate_program_uuid: data.certificateProgramUuid,
        activity_uuid: data.activityUuid,
      },
      body: data.requestBody,
      mediaType: "application/json",
      errors: {
        401: `The authentication credentials required to access this resource are missing or invalid.
`,
        404: `The resource could not be found. Either the resource does not exist or the user does not have authorization to access the resource.
`,
        422: `Unprocessable Entity
`,
      },
    });
  }

  /**
   * Submit Curriculum discussion activity
   * @param data The data for the request.
   * @param data.certificateProgramUuid The unique identifier of a certificate program
   * @param data.activityUuid The unique identifier of the activity.
   * @param data.requestBody
   * @returns CurriculumDiscussionActivityInteractions OK
   * @throws ApiError
   */
  public static submitCurriculumDiscussionActivity(
    data: SubmitCurriculumDiscussionActivityData
  ): CancelablePromise<SubmitCurriculumDiscussionActivityResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/v3/certificate-programs/{certificate_program_uuid}/activities/{activity_uuid}/discussion/submit",
      path: {
        certificate_program_uuid: data.certificateProgramUuid,
        activity_uuid: data.activityUuid,
      },
      body: data.requestBody,
      mediaType: "application/json",
      errors: {
        401: `The authentication credentials required to access this resource are missing or invalid.
`,
        404: `The resource could not be found. Either the resource does not exist or the user does not have authorization to access the resource.
`,
        409: `There was a conflict. This can occur if an evaluation of the submission is in progress.
`,
        422: `Unprocessable Entity
`,
      },
    });
  }

  /**
   * Post Curriculum activity read
   * @param data The data for the request.
   * @param data.certificateProgramUuid The unique identifier of a certificate program
   * @param data.uuid The unique identifier of the activity.
   * @returns unknown OK
   * @throws ApiError
   */
  public static postCurriculumActivityRead(
    data: PostCurriculumActivityReadData
  ): CancelablePromise<PostCurriculumActivityReadResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/v3/certificate-programs/{certificate_program_uuid}/activities/{uuid}/read",
      path: {
        certificate_program_uuid: data.certificateProgramUuid,
        uuid: data.uuid,
      },
      errors: {
        401: `The authentication credentials required to access this resource are missing or invalid.
`,
        404: `The resource could not be found. Either the resource does not exist or the user does not have authorization to access the resource.
`,
      },
    });
  }

  /**
   * Get Certificate Program product and pricing details
   * @param data The data for the request.
   * @param data.certificateProgramUuid The unique identifier of a certificate program
   * @param data.discountSlug Optional discount code to apply to the price
   * @returns CertificateProgramProduct OK
   * @throws ApiError
   */
  public static getCertificateProgramProduct(
    data: GetCertificateProgramProductData
  ): CancelablePromise<GetCertificateProgramProductResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/v3/certificate-programs/{certificate_program_uuid}/product",
      path: {
        certificate_program_uuid: data.certificateProgramUuid,
      },
      query: {
        discount_slug: data.discountSlug,
      },
      errors: {
        401: `The authentication credentials required to access this resource are missing or invalid.
`,
        404: `The resource could not be found. Either the resource does not exist or the user does not have authorization to access the resource.
`,
      },
    });
  }

  /**
   * Return all available SKUs (tiered products) for the certificate program
   * @param data The data for the request.
   * @param data.certificateProgramUuid The unique identifier of a certificate program
   * @param data.discountSlugs
   * @returns CertificateProgramProducts OK
   * @throws ApiError
   */
  public static listCertificateProgramProducts(
    data: ListCertificateProgramProductsData
  ): CancelablePromise<ListCertificateProgramProductsResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/v3/certificate-programs/{certificate_program_uuid}/products",
      path: {
        certificate_program_uuid: data.certificateProgramUuid,
      },
      query: {
        discount_slugs: data.discountSlugs,
      },
      errors: {
        401: "The authentication credentials required to access this resource are missing or invalid.",
        404: "The resource could not be found. Either the resource does not exist or the user does not have authorization to access the resource.",
      },
    });
  }

  /**
   * Get a specific Certificate Program product by product UUID with pricing details
   * @param data The data for the request.
   * @param data.certificateProgramUuid The unique identifier of a certificate program
   * @param data.productUuid The unique identifier of a product
   * @param data.discountSlug Optional discount code to apply to the price
   * @returns CertificateProgramProduct OK
   * @throws ApiError
   */
  public static getCertificateProgramProductByUuid(
    data: GetCertificateProgramProductByUuidData
  ): CancelablePromise<GetCertificateProgramProductByUuidResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/v3/certificate-programs/{certificate_program_uuid}/products/{product_uuid}",
      path: {
        certificate_program_uuid: data.certificateProgramUuid,
        product_uuid: data.productUuid,
      },
      query: {
        discount_slug: data.discountSlug,
      },
      errors: {
        401: `The authentication credentials required to access this resource are missing or invalid.
`,
        404: `The resource could not be found. Either the resource does not exist or the user does not have authorization to access the resource.
`,
      },
    });
  }

  /**
   * Get Certificate Program reward
   * @param data The data for the request.
   * @param data.certificateProgramUuid The unique identifier of a certificate program
   * @returns UserCertificateProgramReward OK
   * @throws ApiError
   */
  public static getCertificateProgramReward(
    data: GetCertificateProgramRewardData
  ): CancelablePromise<GetCertificateProgramRewardResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/v3/certificate-programs/{certificate_program_uuid}/reward",
      path: {
        certificate_program_uuid: data.certificateProgramUuid,
      },
      errors: {
        401: `The authentication credentials required to access this resource are missing or invalid.
`,
        404: `The resource could not be found. Either the resource does not exist or the user does not have authorization to access the resource.
`,
      },
    });
  }

  /**
   * Unlock Certificate Program reward
   * @param data The data for the request.
   * @param data.certificateProgramUuid The unique identifier of a certificate program
   * @returns UserCertificateProgramReward Accepted
   * @throws ApiError
   */
  public static postCertificateProgramReward(
    data: PostCertificateProgramRewardData
  ): CancelablePromise<PostCertificateProgramRewardResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/v3/certificate-programs/{certificate_program_uuid}/reward",
      path: {
        certificate_program_uuid: data.certificateProgramUuid,
      },
      errors: {
        401: `The authentication credentials required to access this resource are missing or invalid.
`,
        404: `The resource could not be found. Either the resource does not exist or the user does not have authorization to access the resource.
`,
      },
    });
  }

  /**
   * Post Certificate Program Add-On
   * @param data The data for the request.
   * @param data.certificateProgramUuid The unique identifier of a certificate program
   * @returns unknown OK
   * @throws ApiError
   */
  public static postCertificateProgramAddOn(
    data: PostCertificateProgramAddOnData
  ): CancelablePromise<PostCertificateProgramAddOnResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/v3/certificate-programs/{certificate_program_uuid}/add-ons",
      path: {
        certificate_program_uuid: data.certificateProgramUuid,
      },
      errors: {
        401: `The authentication credentials required to access this resource are missing or invalid.
`,
        404: `The resource could not be found. Either the resource does not exist or the user does not have authorization to access the resource.
`,
      },
    });
  }

  /**
   * Get Certificate Program coupon
   * @param data The data for the request.
   * @param data.certificateProgramUuid The unique identifier of a certificate program
   * @param data.couponCode The code of the coupon
   * @param data.productUuid The unique identifier of the product
   * @returns CertificateProgramCoupon OK
   * @throws ApiError
   */
  public static getCertificateProgramCoupon(
    data: GetCertificateProgramCouponData
  ): CancelablePromise<GetCertificateProgramCouponResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/v3/certificate-programs/{certificate_program_uuid}/coupons/{coupon_code}",
      path: {
        certificate_program_uuid: data.certificateProgramUuid,
        coupon_code: data.couponCode,
      },
      query: {
        product_uuid: data.productUuid,
      },
      errors: {
        404: `The resource could not be found. Either the resource does not exist or the user does not have authorization to access the resource.
`,
      },
    });
  }
}

export class CertificateProgramEnrollmentService {
  /**
   * List Certificate Program Enrollments
   * Get a list of certificate program enrollments
   * @param data The data for the request.
   * @param data.active Filter by active enrollments. If multiple status parameters are provided,
   * the results will be concatenated together.
   *
   * @param data.pending Filter by pending enrollments. If multiple status parameters are provided,
   * the results will be concatenated together.
   *
   * @param data.inactive Filter by inactive enrollments. If multiple status parameters are provided,
   * the results will be concatenated together.
   *
   * @returns CertificateProgramEnrollments OK
   * @throws ApiError
   */
  public static getCertificateProgramEnrollments(
    data: GetCertificateProgramEnrollmentsData = {}
  ): CancelablePromise<GetCertificateProgramEnrollmentsResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/v3/certificate-programs/enrollments",
      query: {
        active: data.active,
        pending: data.pending,
        inactive: data.inactive,
      },
      errors: {
        401: `The authentication credentials required to access this resource are missing or invalid.
`,
      },
    });
  }

  /**
   * Get Certificate Program enrollment
   * @param data The data for the request.
   * @param data.certificateProgramUuid The unique identifier of a certificate program
   * @returns CertificateProgramEnrollment OK
   * @throws ApiError
   */
  public static getCertificateProgramEnrollment(
    data: GetCertificateProgramEnrollmentData
  ): CancelablePromise<GetCertificateProgramEnrollmentResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/v3/certificate-programs/{certificate_program_uuid}/enrollment",
      path: {
        certificate_program_uuid: data.certificateProgramUuid,
      },
      errors: {
        401: `The authentication credentials required to access this resource are missing or invalid.
`,
        404: `The resource could not be found. Either the resource does not exist or the user does not have authorization to access the resource.
`,
      },
    });
  }

  /**
   * Enroll in a certificate program.
   *
   * @param data The data for the request.
   * @param data.requestBody
   * @param data.certificateProgramUuid The unique identifier of a certificate program
   * @returns unknown OK
   * @throws ApiError
   */
  public static enrollInCertificateProgram(
    data: EnrollInCertificateProgramData
  ): CancelablePromise<EnrollInCertificateProgramResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/v3/certificate-programs/{certificate_program_uuid}/enrollment",
      path: {
        certificate_program_uuid: data.certificateProgramUuid,
      },
      body: data.requestBody,
      mediaType: "application/json",
      errors: {
        401: `The authentication credentials required to access this resource are missing or invalid.
`,
        404: `The resource could not be found. Either the resource does not exist or the user does not have authorization to access the resource.
`,
        422: `Unprocessable Entity
`,
      },
    });
  }

  /**
   * Withdraw from a certificate program. This is only available for non-production environments.
   *
   * @param data The data for the request.
   * @param data.certificateProgramUuid The unique identifier of a certificate program
   * @returns void No Content
   * @throws ApiError
   */
  public static withdrawFromCertificateProgram(
    data: WithdrawFromCertificateProgramData
  ): CancelablePromise<WithdrawFromCertificateProgramResponse> {
    return __request(OpenAPI, {
      method: "DELETE",
      url: "/api/v3/certificate-programs/{certificate_program_uuid}/enrollment",
      path: {
        certificate_program_uuid: data.certificateProgramUuid,
      },
      errors: {
        401: `The authentication credentials required to access this resource are missing or invalid.
`,
        404: `The resource could not be found. Either the resource does not exist or the user does not have authorization to access the resource.
`,
      },
    });
  }
}

export class AcceleratorService {
  /**
   * Get UUID for Accelerator user
   * @param data The data for the request.
   * @param data.requestBody
   * @returns AcceleratorUser OK
   * @throws ApiError
   */
  public static v3GetUser(
    data: V3GetUserData = {}
  ): CancelablePromise<V3GetUserResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/v3/accelerator/user",
      body: data.requestBody,
      mediaType: "application/json",
      errors: {
        400: "The request body was invalid.",
      },
    });
  }
}

export class GrowthService {
  /**
   * gets categories & subcategories belonging to the new PALM taxonomy
   * @returns GrowthCategory OK
   * @throws ApiError
   */
  public static getGrowthCategories(): CancelablePromise<GetGrowthCategoriesResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/v3/growth/categories",
    });
  }

  /**
   * Gets content details such as courses, series, or sessions
   * @returns GrowthContent OK
   * @throws ApiError
   */
  public static getGrowthContent(): CancelablePromise<GetGrowthContentResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/v3/growth/content",
    });
  }

  /**
   * Gets recommended lessons for the quiz results page
   * @returns GrowthSubcategoryWithLessons OK
   * @throws ApiError
   */
  public static getQuizRecommendedLessons(): CancelablePromise<GetQuizRecommendedLessonsResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/v3/growth/quiz-results/recommended-lessons",
    });
  }

  /**
   * Gets category media (videos, images) for the intermediate stages of the quiz
   * @returns GrowthCategoryWithMedia OK
   * @throws ApiError
   */
  public static getQuizCategoryMedia(): CancelablePromise<GetQuizCategoryMediaResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/v3/growth/quiz/category-media",
    });
  }

  /**
   * Gets outcomes
   * @returns Outcome OK
   * @throws ApiError
   */
  public static getOutcomes(): CancelablePromise<GetOutcomesResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/v3/growth/outcomes",
    });
  }

  /**
   * Retrieves content (e.g., courses, series, or sessions) along with their associated outcomes, ordered by relevance rank
   * @returns ContentOutcome OK
   * @throws ApiError
   */
  public static getContentOutcomes(): CancelablePromise<GetContentOutcomesResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/v3/growth/content-outcomes",
    });
  }

  /**
   * Captures email addresses for marketing and analytics purposes
   * @param data The data for the request.
   * @param data.requestBody
   * @returns EmailCaptureResponse Email captured successfully
   * @throws ApiError
   */
  public static createEmailCapture(
    data: CreateEmailCaptureData
  ): CancelablePromise<CreateEmailCaptureResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/v3/growth/email-capture",
      body: data.requestBody,
      mediaType: "application/json",
      errors: {
        400: "Bad request - email is required",
      },
    });
  }
}

export class DecagonService {
  /**
   * GET Decagon User Token JWT
   * @returns DecagonUserToken Get a valid JWT
   * @throws ApiError
   */
  public static getUserToken(): CancelablePromise<GetUserTokenResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/v3/decagon/user-token",
    });
  }
}

export class CommerceService {
  /**
   * gets product and pricing plans for a given product
   * @param data The data for the request.
   * @param data.productName The name of the product to retrieve
   * @returns CommerceProduct OK
   * @throws ApiError
   */
  public static getCommerceProduct(
    data: GetCommerceProductData
  ): CancelablePromise<GetCommerceProductResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/v3/commerce/products/{product_name}",
      path: {
        product_name: data.productName,
      },
    });
  }

  /**
   * Gets pricing plans for a given purchase plan
   * @param data The data for the request.
   * @param data.slug The name of the purchase-plan to retrieve
   * @returns CommercePurchasePlan OK
   * @throws ApiError
   */
  public static getCommercePurchasePlans(
    data: GetCommercePurchasePlansData
  ): CancelablePromise<GetCommercePurchasePlansResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/v3/commerce/purchase-plans/{slug}",
      path: {
        slug: data.slug,
      },
    });
  }

  /**
   * Redeem giftcard
   * Gets email and giftcode and verifies user has no active subscription
   * @param data The data for the request.
   * @param data.requestBody Giftcode for redemption
   * @returns SubscriptionDetails OK
   * @throws ApiError
   */
  public static redeemGiftcard(
    data: RedeemGiftcardData
  ): CancelablePromise<RedeemGiftcardResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/v3/commerce/bhn/redeem-giftcode",
      body: data.requestBody,
      mediaType: "application/json",
      errors: {
        400: "Giftcode Invalid",
        409: "Subscription invalid",
        503: "Service Unavailable",
      },
    });
  }
}
